import React, { useState, useEffect, useRef, useCallback } from 'react';

const API = 'https://openhitster.onrender.com';
// const API = 'http://127.0.0.1:8000';

// ─── Translations ─────────────────────────────────────────────────────────────

const T = {
  nl: {
    subtitle: 'Ken jij het nummer? 🕵️',
    howItWorksTitle: '🎮 Hoe werkt het?',
    howItWorksIntro: 'Open Hitster is volledig gratis. Je hoeft de handleiding hieronder slechts één keer te volgen om de app klaar te zetten.',
    howItWorksTips: [
      'Het spel verbindt met jouw Spotify account. Een betaald Spotify-abonnement is vereist.',
      'Zorg dat je een afspeellijst op jouw profiel hebt waarmee je wil spelen. Je kan ook een externe afspeellijst aan jouw profiel toevoegen.',
      'Open Spotify op het apparaat waarop je wil spelen (gsm, tablet, pc, …) vóór je inlogt.',
      'Na het inloggen kies je apparaat, afspeellijst en instellingen. Zorg voor pen en papier om de jaartallen bij te houden.',
    ],
    spotifyConnectionTitle: '🔑 Spotify verbinding',
    spotifyGuideTitle: '📋 Hoe maak je een Spotify app?',
    spotifySteps: (api) => [
      <>Ga naar <a href="https://developer.spotify.com/dashboard" target="_blank" rel="noreferrer" style={{ color: '#1DB954' }}>developer.spotify.com/dashboard</a> en log in.</>,
      <>Klik op <strong style={{ color: '#fff' }}>Create app</strong>.</>,
      <>Vul een naam en beschrijving in (mag van alles zijn).</>,
      <>Plak bij <strong style={{ color: '#fff' }}>Redirect URIs</strong> de volgende URL en klik op <strong style={{ color: '#fff' }}>Add</strong>:<br /><code style={{ color: '#00e5ff', fontSize: '0.7rem', wordBreak: 'break-all' }}>{api}/callback</code></>,
      <>Vink bij <strong style={{ color: '#fff' }}>APIs used</strong> de optie <strong style={{ color: '#fff' }}>Web API</strong> en <strong style={{ color: '#fff' }}>Web Playback SDK</strong> aan.</>,
      <>Klik op <strong style={{ color: '#fff' }}>Save</strong>. Ga dan naar <strong style={{ color: '#fff' }}>Settings</strong> om je <strong style={{ color: '#fff' }}>Client ID</strong> en <strong style={{ color: '#fff' }}>Client Secret</strong> te kopiëren.</>,
    ],
    braveTitle: '🔍 Brave Search API',
    braveDesc: <>Verplicht voor eigen API key — voor nauwkeurige releasejaren. Gratis via <strong style={{ color: '#ff9500' }}>$5 gratis credits per maand</strong>.</>,
    braveGuideTitle: '📋 Hoe krijg je een Brave API key?',
    braveSteps: [
      <>Ga naar <a href="https://api.search.brave.com/register" target="_blank" rel="noreferrer" style={{ color: '#ff9500' }}>api.search.brave.com/register</a> en maak een account aan.</>,
      <>Kies het <strong style={{ color: '#fff' }}>Free</strong> plan — je krijgt automatisch $5 gratis credits per maand.</>,
      <>Ga naar <strong style={{ color: '#fff' }}>API Keys</strong> en genereer een nieuwe sleutel.</>,
      <>Kopieer de key en plak hem hieronder.</>,
    ],
    braveKeyPlaceholder: 'Brave API key',
    loginButton: '🎧 Login met Spotify',
    donateText: 'Steun dit en andere gratis projecten via',
    settingsTitle: 'Instellingen',
    choosePlaylist: '🎼 Kies een afspeellijst',
    tracks: 'nummers',
    startPosition: '▶️ Start positie',
    startBegin: 'Begin',
    startBeginDesc: 'Altijd vanaf het begin',
    startRandom: 'Random',
    startRandomDesc: 'Willekeurig in het nummer',
    listenDuration: '⏱ Luisterduur',
    durationFull: '🎵 Volledig nummer',
    duration30: '⏱ 30 seconden',
    duration20: '⚡ 20 seconden',
    duration10: '💨 10 seconden',
    deviceTitle: '📱 Afspeelapparaat',
    noDevices: 'Geen apparaten gevonden.',
    noDevicesHint: 'Start Spotify eerst op je toestel.',
    openSpotify: '🎵 Open Spotify',
    active: 'Actief',
    startGame: '🎮 Spel starten!',
    loading: 'Laden...',
    round: (n) => `🕵️ Ronde ${n}`,
    playlistRestarted: 'Alle nummers gespeeld — afspeellijst opnieuw geschud!',
    seekingPosition: '⏩ Positie instellen...',
    readyToStart: 'Klaar om te beginnen!',
    startFirst: '🎲 Start eerste nummer!',
    musicPlaying: 'Muziek speelt...',
    stoppedAfterTimer: '⏸ Gestopt na tijdslimiet',
    searching: '🔍 Zoeken...',
    reveal: '🎭 REVEAL!',
    nextTrack: '⏭ Volgend nummer!',
    pause: '⏸ Pauzeer',
    randomStart: '🎲 Random start',
    beginStart: '⏮ Begin',
    fullTrack: '🎵 Volledig',
    loadingPlaylist: 'Afspeellijst laden...',
    installTitle: 'Installeer Open Hitster',
    installSubtitle: 'Voeg toe aan je homescreen',
    install: 'Installeer',
    logout: 'Logout',
    back: '← Terug',
    // Mode selection
    chooseMode: '🎮 Hoe wil je spelen?',
    modeSpotify: '🎧 Via Spotify',
    modeSpotifyDesc: 'Premium-abonnement vereist',
    modeFree: '🆓 Gratis spelen',
    modeFreeDesc: 'Geen account nodig · YouTube & Deezer',
    // Free path — Deezer search
    deezerSearchTitle: '🎵 Kies een Deezer-playlist',
    searchPlaceholder: 'Zoek een playlist...',
    searchBtn: '🔍 Zoeken',
    pasteHint: 'Of plak een Deezer playlist-ID of URL',
    noResults: 'Geen resultaten gevonden.',
    enriching: '⏳ Releasejaren ophalen…',
    // Free path — video settings
    videoSettingsTitle: '🎬 Video-instellingen',
    revealVideoLabel: 'Video tonen bij onthulling',
    hintModeTitle: 'Video-hint tijdens raden',
    hintOff: 'Uit',
    hintOffDesc: 'Zwart scherm',
    hintPeek: 'Wazig',
    hintPeekDesc: 'Vervaagd beeld als hint',
    hintFull: 'Vol',
    hintFullDesc: 'Volledige video zichtbaar',
    startFreeGame: '🎮 Spel starten!',
    // Free game
    videoHintBtn: '📺 Video-hint',
    videoLoading: 'Video laden...',
    videoError: 'Video niet beschikbaar',
    ytApiMissing: 'YouTube niet geconfigureerd op server',
    // Films & Series modus
    modeMovies: '🎬 Films & Series',
    modeMoviesDesc: 'Raad het jaar — IMDB top-rated',
    movieSetupTitle: '🎬 Films & Series',
    contentType: 'Wat wil je raden?',
    contentMovies: '🎬 Films',
    contentTv: '📺 Series',
    contentBoth: '🎭 Alles',
    genreFilter: 'Genre (optioneel)',
    genreAll: 'Alle genres',
    itemCountLabel: 'Aantal items',
    hintTypesLabel: 'Hint-types',
    hintSynopsis: '📝 Synopsis',
    hintSynopsisDesc: 'Verhaal als hint',
    hintImage: '🖼️ Beeld',
    hintImageDesc: 'Filmstill als hint',
    hintTrailer: '🎬 Trailer',
    hintTrailerDesc: 'YouTube trailer',
    hintSoundtrack: '🎵 Soundtrack',
    hintSoundtrackDesc: 'Muziekthema als hint',
    revealVideoMovieLabel: 'Video tonen bij onthulling',
    minScoreLabel: 'Minimale score',
    minScoreHint: (s) => `Enkel films/series met score ≥ ${s}`,
    minYearLabel: '📅 Vanaf jaartal',
    minYearHint: (y) => y === 1900 ? 'Alle jaren (geen beperking)' : `Enkel films/series vanaf ${y}`,
    westernOnlyLabel: '🌍 Taalfilter',
    westernOnlyOn: 'Westers',
    westernOnlyOnDesc: 'Engels, Frans, Duits, Nederlands, Spaans, Italiaans, …',
    westernOnlyOff: 'Alles',
    westernOnlyOffDesc: 'Inclusief Aziatische, Arabische en andere content',
    loadingGenres: 'Genres laden...',
    loadingContent: 'Content laden...',
    startMovieGame: '🎬 Spel starten!',
    movieRound: (n) => `🎬 Ronde ${n}`,
    moviePlaying: 'Raad het jaar!',
    movieStopped: 'Tijd is op!',
    synopsisRevealHint: 'Toon hint',
    switchHint: '🔄 Andere hint',
    revealMovie: '🎭 ONTHUL!',
    nextMovie: '⏭ Volgende!',
    noTmdbKey: 'TMDB niet geconfigureerd op server',
    hintTypeLabel: (type) => ({ synopsis: '📝 Synopsis', image: '🖼️ Beeld', trailer: '🎬 Trailer', soundtrack: '🎵 Soundtrack' }[type] || type),
    movieRestarted: 'Alle items gespeeld — opnieuw geschud!',
  },
  en: {
    subtitle: 'Do you know the song? 🕵️',
    howItWorksTitle: '🎮 How does it work?',
    howItWorksIntro: 'Open Hitster is completely free. You only need to follow the guide below once to set up the app.',
    howItWorksTips: [
      'The game connects to your Spotify account. A paid Spotify subscription is required.',
      'Make sure you have a playlist on your profile to play with. You can also add an external playlist to your profile.',
      'Open Spotify on the device you want to play on (phone, tablet, pc, …) before logging in.',
      'After logging in, choose device, playlist and settings. Have pen and paper ready to note down the years.',
    ],
    spotifyConnectionTitle: '🔑 Spotify connection',
    spotifyGuideTitle: '📋 How to create a Spotify app?',
    spotifySteps: (api) => [
      <>Go to <a href="https://developer.spotify.com/dashboard" target="_blank" rel="noreferrer" style={{ color: '#1DB954' }}>developer.spotify.com/dashboard</a> and log in.</>,
      <>Click on <strong style={{ color: '#fff' }}>Create app</strong>.</>,
      <>Fill in a name and description (anything goes).</>,
      <>Paste this URL in the <strong style={{ color: '#fff' }}>Redirect URIs</strong> field and click <strong style={{ color: '#fff' }}>Add</strong>:<br /><code style={{ color: '#00e5ff', fontSize: '0.7rem', wordBreak: 'break-all' }}>{api}/callback</code></>,
      <>Under <strong style={{ color: '#fff' }}>APIs used</strong>, check <strong style={{ color: '#fff' }}>Web API</strong> and <strong style={{ color: '#fff' }}>Web Playback SDK</strong>.</>,
      <>Click <strong style={{ color: '#fff' }}>Save</strong>. Then go to <strong style={{ color: '#fff' }}>Settings</strong> to copy your <strong style={{ color: '#fff' }}>Client ID</strong> and <strong style={{ color: '#fff' }}>Client Secret</strong>.</>,
    ],
    braveTitle: '🔍 Brave Search API',
    braveDesc: <>Required for own API key — for accurate release years. Free via <strong style={{ color: '#ff9500' }}>$5 free credits per month</strong>.</>,
    braveGuideTitle: '📋 How to get a Brave API key?',
    braveSteps: [
      <>Go to <a href="https://api.search.brave.com/register" target="_blank" rel="noreferrer" style={{ color: '#ff9500' }}>api.search.brave.com/register</a> and create an account.</>,
      <>Choose the <strong style={{ color: '#fff' }}>Free</strong> plan — you automatically get $5 free credits per month.</>,
      <>Go to <strong style={{ color: '#fff' }}>API Keys</strong> and generate a new key.</>,
      <>Copy the key and paste it below.</>,
    ],
    braveKeyPlaceholder: 'Brave API key',
    loginButton: '🎧 Login with Spotify',
    donateText: 'Support this and other free projects via',
    settingsTitle: 'Settings',
    choosePlaylist: '🎼 Choose a playlist',
    tracks: 'tracks',
    startPosition: '▶️ Start position',
    startBegin: 'Beginning',
    startBeginDesc: 'Always from the start',
    startRandom: 'Random',
    startRandomDesc: 'Random position in the track',
    listenDuration: '⏱ Listen duration',
    durationFull: '🎵 Full track',
    duration30: '⏱ 30 seconds',
    duration20: '⚡ 20 seconds',
    duration10: '💨 10 seconds',
    deviceTitle: '📱 Playback device',
    noDevices: 'No devices found.',
    noDevicesHint: 'Open Spotify on your device first.',
    openSpotify: '🎵 Open Spotify',
    active: 'Active',
    startGame: '🎮 Start game!',
    loading: 'Loading...',
    round: (n) => `🕵️ Round ${n}`,
    playlistRestarted: 'All tracks played — playlist reshuffled!',
    seekingPosition: '⏩ Setting position...',
    readyToStart: 'Ready to start!',
    startFirst: '🎲 Start first track!',
    musicPlaying: 'Music playing...',
    stoppedAfterTimer: '⏸ Stopped after time limit',
    searching: '🔍 Searching...',
    reveal: '🎭 REVEAL!',
    nextTrack: '⏭ Next track!',
    pause: '⏸ Pause',
    randomStart: '🎲 Random start',
    beginStart: '⏮ Beginning',
    fullTrack: '🎵 Full',
    loadingPlaylist: 'Loading playlist...',
    installTitle: 'Install Open Hitster',
    installSubtitle: 'Add to your homescreen',
    install: 'Install',
    logout: 'Logout',
    back: '← Back',
    chooseMode: '🎮 How do you want to play?',
    modeSpotify: '🎧 Via Spotify',
    modeSpotifyDesc: 'Premium subscription required',
    modeFree: '🆓 Play for free',
    modeFreeDesc: 'No account needed · YouTube & Deezer',
    deezerSearchTitle: '🎵 Choose a Deezer playlist',
    searchPlaceholder: 'Search for a playlist...',
    searchBtn: '🔍 Search',
    pasteHint: 'Or paste a Deezer playlist ID or URL',
    noResults: 'No results found.',
    enriching: '⏳ Fetching release years…',
    videoSettingsTitle: '🎬 Video settings',
    revealVideoLabel: 'Show video on reveal',
    hintModeTitle: 'Video hint while guessing',
    hintOff: 'Off',
    hintOffDesc: 'Black screen',
    hintPeek: 'Blur',
    hintPeekDesc: 'Blurred image as hint',
    hintFull: 'Full',
    hintFullDesc: 'Full video visible',
    startFreeGame: '🎮 Start game!',
    videoHintBtn: '📺 Video hint',
    videoLoading: 'Loading video...',
    videoError: 'Video not available',
    ytApiMissing: 'YouTube not configured on server',
    // Movies & Series mode
    modeMovies: '🎬 Movies & Series',
    modeMoviesDesc: 'Guess the year — IMDB top-rated',
    movieSetupTitle: '🎬 Movies & Series',
    contentType: 'What do you want to guess?',
    contentMovies: '🎬 Movies',
    contentTv: '📺 Series',
    contentBoth: '🎭 Everything',
    genreFilter: 'Genre (optional)',
    genreAll: 'All genres',
    itemCountLabel: 'Number of items',
    hintTypesLabel: 'Hint types',
    hintSynopsis: '📝 Synopsis',
    hintSynopsisDesc: 'Story as a hint',
    hintImage: '🖼️ Image',
    hintImageDesc: 'Film still as a hint',
    hintTrailer: '🎬 Trailer',
    hintTrailerDesc: 'YouTube trailer',
    hintSoundtrack: '🎵 Soundtrack',
    hintSoundtrackDesc: 'Music theme as hint',
    revealVideoMovieLabel: 'Show video on reveal',
    minScoreLabel: 'Minimum score',
    minScoreHint: (s) => `Only movies/series with score ≥ ${s}`,
    minYearLabel: '📅 From year',
    minYearHint: (y) => y === 1900 ? 'All years (no restriction)' : `Only movies/series from ${y} onwards`,
    westernOnlyLabel: '🌍 Language filter',
    westernOnlyOn: 'Western',
    westernOnlyOnDesc: 'English, French, German, Dutch, Spanish, Italian, …',
    westernOnlyOff: 'All',
    westernOnlyOffDesc: 'Including Asian, Arabic and other content',
    loadingGenres: 'Loading genres...',
    loadingContent: 'Loading content...',
    startMovieGame: '🎬 Start game!',
    movieRound: (n) => `🎬 Round ${n}`,
    moviePlaying: 'Guess the year!',
    movieStopped: 'Time is up!',
    synopsisRevealHint: 'Show hint',
    switchHint: '🔄 Switch hint',
    revealMovie: '🎭 REVEAL!',
    nextMovie: '⏭ Next!',
    noTmdbKey: 'TMDB not configured on server',
    hintTypeLabel: (type) => ({ synopsis: '📝 Synopsis', image: '🖼️ Image', trailer: '🎬 Trailer', soundtrack: '🎵 Soundtrack' }[type] || type),
    movieRestarted: 'All items played — reshuffled!',
  },
  fr: {
    subtitle: 'Tu connais la chanson ? 🕵️',
    howItWorksTitle: '🎮 Comment ça marche ?',
    howItWorksIntro: "Open Hitster est entièrement gratuit. Tu n'as besoin de suivre le guide ci-dessous qu'une seule fois pour configurer l'application.",
    howItWorksTips: [
      'Le jeu se connecte à ton compte Spotify. Un abonnement Spotify payant est requis.',
      "Assure-toi d'avoir une playlist sur ton profil avec laquelle tu veux jouer. Tu peux aussi ajouter une playlist externe à ton profil.",
      "Ouvre Spotify sur l'appareil sur lequel tu veux jouer (téléphone, tablette, pc, …) avant de te connecter.",
      "Après connexion, choisis l'appareil, la playlist et les paramètres. Prévois du papier et un stylo pour noter les années.",
    ],
    spotifyConnectionTitle: '🔑 Connexion Spotify',
    spotifyGuideTitle: '📋 Comment créer une app Spotify ?',
    spotifySteps: (api) => [
      <>Va sur <a href="https://developer.spotify.com/dashboard" target="_blank" rel="noreferrer" style={{ color: '#1DB954' }}>developer.spotify.com/dashboard</a> et connecte-toi.</>,
      <>Clique sur <strong style={{ color: '#fff' }}>Create app</strong>.</>,
      <>Remplis un nom et une description (n'importe quoi).</>,
      <>Colle l'URL suivante dans le champ <strong style={{ color: '#fff' }}>Redirect URIs</strong> et clique sur <strong style={{ color: '#fff' }}>Add</strong> :<br /><code style={{ color: '#00e5ff', fontSize: '0.7rem', wordBreak: 'break-all' }}>{api}/callback</code></>,
      <>Sous <strong style={{ color: '#fff' }}>APIs used</strong>, coche <strong style={{ color: '#fff' }}>Web API</strong> et <strong style={{ color: '#fff' }}>Web Playback SDK</strong>.</>,
      <>Clique sur <strong style={{ color: '#fff' }}>Save</strong>. Va ensuite dans <strong style={{ color: '#fff' }}>Settings</strong> pour copier ton <strong style={{ color: '#fff' }}>Client ID</strong> et ton <strong style={{ color: '#fff' }}>Client Secret</strong>.</>,
    ],
    braveTitle: '🔍 Brave Search API',
    braveDesc: <>Obligatoire pour la clé API perso — pour des années de sortie précises. Gratuit via <strong style={{ color: '#ff9500' }}>$5 de crédits gratuits par mois</strong>.</>,
    braveGuideTitle: '📋 Comment obtenir une clé API Brave ?',
    braveSteps: [
      <>Va sur <a href="https://api.search.brave.com/register" target="_blank" rel="noreferrer" style={{ color: '#ff9500' }}>api.search.brave.com/register</a> et crée un compte.</>,
      <>Choisis le plan <strong style={{ color: '#fff' }}>Free</strong> — tu reçois automatiquement $5 de crédits gratuits par mois.</>,
      <>Va dans <strong style={{ color: '#fff' }}>API Keys</strong> et génère une nouvelle clé.</>,
      <>Copie la clé et colle-la ci-dessous.</>,
    ],
    braveKeyPlaceholder: 'Clé API Brave',
    loginButton: '🎧 Se connecter avec Spotify',
    donateText: "Soutiens ce projet et d'autres projets gratuits via",
    settingsTitle: 'Paramètres',
    choosePlaylist: '🎼 Choisir une playlist',
    tracks: 'morceaux',
    startPosition: '▶️ Position de départ',
    startBegin: 'Début',
    startBeginDesc: 'Toujours depuis le début',
    startRandom: 'Aléatoire',
    startRandomDesc: 'Position aléatoire dans le morceau',
    listenDuration: "⏱ Durée d'écoute",
    durationFull: '🎵 Morceau complet',
    duration30: '⏱ 30 secondes',
    duration20: '⚡ 20 secondes',
    duration10: '💨 10 secondes',
    deviceTitle: '📱 Appareil de lecture',
    noDevices: 'Aucun appareil trouvé.',
    noDevicesHint: "Ouvre d'abord Spotify sur ton appareil.",
    openSpotify: '🎵 Ouvrir Spotify',
    active: 'Actif',
    startGame: '🎮 Lancer le jeu !',
    loading: 'Chargement...',
    round: (n) => `🕵️ Manche ${n}`,
    playlistRestarted: 'Tous les morceaux joués — playlist remélangée !',
    seekingPosition: '⏩ Réglage de la position...',
    readyToStart: 'Prêt à commencer !',
    startFirst: '🎲 Démarrer le premier morceau !',
    musicPlaying: 'Musique en cours...',
    stoppedAfterTimer: '⏸ Arrêté après la limite de temps',
    searching: '🔍 Recherche...',
    reveal: '🎭 RÉVÉLER !',
    nextTrack: '⏭ Morceau suivant !',
    pause: '⏸ Pause',
    randomStart: '🎲 Départ aléatoire',
    beginStart: '⏮ Début',
    fullTrack: '🎵 Complet',
    loadingPlaylist: 'Chargement de la playlist...',
    installTitle: 'Installer Open Hitster',
    installSubtitle: "Ajouter à l'écran d'accueil",
    install: 'Installer',
    logout: 'Déconnexion',
    back: '← Retour',
    chooseMode: '🎮 Comment veux-tu jouer ?',
    modeSpotify: '🎧 Via Spotify',
    modeSpotifyDesc: 'Abonnement Premium requis',
    modeFree: '🆓 Jouer gratuitement',
    modeFreeDesc: 'Pas de compte nécessaire · YouTube & Deezer',
    deezerSearchTitle: '🎵 Choisir une playlist Deezer',
    searchPlaceholder: 'Rechercher une playlist...',
    searchBtn: '🔍 Rechercher',
    pasteHint: 'Ou colle un ID ou URL de playlist Deezer',
    noResults: 'Aucun résultat trouvé.',
    enriching: '⏳ Récupération des années…',
    videoSettingsTitle: '🎬 Paramètres vidéo',
    revealVideoLabel: 'Afficher la vidéo lors de la révélation',
    hintModeTitle: 'Indice vidéo pendant la devinette',
    hintOff: 'Désactivé',
    hintOffDesc: 'Écran noir',
    hintPeek: 'Flou',
    hintPeekDesc: 'Image floue comme indice',
    hintFull: 'Plein',
    hintFullDesc: 'Vidéo complète visible',
    startFreeGame: '🎮 Lancer le jeu !',
    videoHintBtn: '📺 Indice vidéo',
    videoLoading: 'Chargement de la vidéo...',
    videoError: 'Vidéo non disponible',
    ytApiMissing: 'YouTube non configuré sur le serveur',
    // Mode Films & Séries
    modeMovies: '🎬 Films & Séries',
    modeMoviesDesc: 'Devine l\'année — top IMDB',
    movieSetupTitle: '🎬 Films & Séries',
    contentType: 'Que veux-tu deviner ?',
    contentMovies: '🎬 Films',
    contentTv: '📺 Séries',
    contentBoth: '🎭 Tout',
    genreFilter: 'Genre (optionnel)',
    genreAll: 'Tous les genres',
    itemCountLabel: 'Nombre d\'éléments',
    hintTypesLabel: 'Types d\'indices',
    hintSynopsis: '📝 Synopsis',
    hintSynopsisDesc: 'L\'histoire comme indice',
    hintImage: '🖼️ Image',
    hintImageDesc: 'Plan du film comme indice',
    hintTrailer: '🎬 Bande-annonce',
    hintTrailerDesc: 'Bande-annonce YouTube',
    hintSoundtrack: '🎵 Bande sonore',
    hintSoundtrackDesc: 'Thème musical comme indice',
    revealVideoMovieLabel: 'Afficher la vidéo lors de la révélation',
    minScoreLabel: 'Score minimum',
    minScoreHint: (s) => `Uniquement les films/séries avec score ≥ ${s}`,
    minYearLabel: '📅 À partir de l\'année',
    minYearHint: (y) => y === 1900 ? 'Toutes les années (sans restriction)' : `Uniquement les films/séries à partir de ${y}`,
    westernOnlyLabel: '🌍 Filtre de langue',
    westernOnlyOn: 'Occidental',
    westernOnlyOnDesc: 'Anglais, français, allemand, néerlandais, espagnol, italien, …',
    westernOnlyOff: 'Tout',
    westernOnlyOffDesc: 'Y compris le contenu asiatique, arabe et autre',
    loadingGenres: 'Chargement des genres...',
    loadingContent: 'Chargement du contenu...',
    startMovieGame: '🎬 Lancer le jeu !',
    movieRound: (n) => `🎬 Manche ${n}`,
    moviePlaying: 'Devine l\'année !',
    movieStopped: 'Temps écoulé !',
    synopsisRevealHint: 'Afficher l\'indice',
    switchHint: '🔄 Changer d\'indice',
    revealMovie: '🎭 RÉVÉLER !',
    nextMovie: '⏭ Suivant !',
    noTmdbKey: 'TMDB non configuré sur le serveur',
    hintTypeLabel: (type) => ({ synopsis: '📝 Synopsis', image: '🖼️ Image', trailer: '🎬 Bande-annonce', soundtrack: '🎵 Bande sonore' }[type] || type),
    movieRestarted: 'Tous les éléments joués — remélangé !',
  },
};

const LangContext = React.createContext({ lang: 'nl', setLang: () => {} });
function useLang() {
  const { lang, setLang } = React.useContext(LangContext);
  return { t: T[lang] || T.nl, lang, setLang };
}

// ─── Helpers ──────────────────────────────────────────────────────────────────

function shuffle(arr) {
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

function parseDeezerInput(input) {
  const m = input.match(/deezer\.com\/(?:[a-z]{2}\/)?playlist\/(\d+)/);
  if (m) return m[1];
  if (/^\d+$/.test(input.trim())) return input.trim();
  return null;
}

function useToken() {
  const [token, setToken] = useState(() => {
    const stored = localStorage.getItem('sp_token');
    const expires = parseInt(localStorage.getItem('sp_expires') || '0', 10);
    return (stored && expires > Date.now() + 60 * 1000) ? stored : null;
  });
  const [refreshToken, setRefreshToken] = useState(() => localStorage.getItem('sp_refresh') || null);
  const refreshingRef = useRef(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const at = params.get('access_token');
    const rt = params.get('refresh_token');
    const ei = params.get('expires_in');
    if (at) {
      const expiresAt = Date.now() + (parseInt(ei, 10) || 3600) * 1000;
      localStorage.setItem('sp_token', at);
      if (rt) localStorage.setItem('sp_refresh', rt);
      localStorage.setItem('sp_expires', String(expiresAt));
      setToken(at);
      if (rt) setRefreshToken(rt);
      window.history.replaceState({}, '', '/');
    }
  }, []);

  const doRefresh = useCallback(async () => {
    if (refreshingRef.current) return;
    const rt = localStorage.getItem('sp_refresh');
    if (!rt) return;
    refreshingRef.current = true;
    try {
      const clientId = localStorage.getItem('sp_custom_client_id') || '';
      const clientSecret = localStorage.getItem('sp_custom_client_secret') || '';
      const res = await fetch(`${API}/refresh`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ refresh_token: rt, client_id: clientId, client_secret: clientSecret }),
      });
      if (!res.ok) return;
      const data = await res.json();
      if (!data.access_token) return;
      const newExpiresAt = Date.now() + (data.expires_in || 3600) * 1000;
      localStorage.setItem('sp_token', data.access_token);
      localStorage.setItem('sp_expires', String(newExpiresAt));
      if (data.refresh_token) {
        localStorage.setItem('sp_refresh', data.refresh_token);
        setRefreshToken(data.refresh_token);
      }
      setToken(data.access_token);
    } catch {
      // silent fail
    } finally {
      refreshingRef.current = false;
    }
  }, []);

  useEffect(() => {
    const storedRefresh = localStorage.getItem('sp_refresh');
    if (!storedRefresh) return;
    const expiresAt = parseInt(localStorage.getItem('sp_expires') || '0', 10);
    if (!token && expiresAt > 0) doRefresh();
    const interval = setInterval(() => {
      const exp = parseInt(localStorage.getItem('sp_expires') || '0', 10);
      if (exp && (exp - Date.now()) < 5 * 60 * 1000) doRefresh();
    }, 60 * 1000);
    return () => clearInterval(interval);
  }, [doRefresh]); // eslint-disable-line

  const logout = () => {
    localStorage.removeItem('sp_token');
    localStorage.removeItem('sp_refresh');
    localStorage.removeItem('sp_expires');
    setToken(null);
    setRefreshToken(null);
  };

  return { token, refreshToken, logout };
}

// ─── Sub-components ───────────────────────────────────────────────────────────

function Equalizer({ playing }) {
  return (
    <div style={{ display: 'flex', alignItems: 'flex-end', gap: 3, height: 28 }}>
      {[1, 2, 3, 4, 5].map(i => (
        <div key={i} style={{
          width: 4,
          borderRadius: 2,
          background: `linear-gradient(to top, #ff2d78, #ffd600)`,
          animation: playing ? `equalizer ${0.4 + i * 0.12}s ease-in-out infinite alternate` : 'none',
          height: playing ? undefined : 4,
          animationDelay: `${i * 0.07}s`,
        }} />
      ))}
    </div>
  );
}

function NeonButton({ children, onClick, color = '#ff2d78', disabled, style = {}, size = 'md' }) {
  const pads = size === 'lg' ? '18px 36px' : size === 'sm' ? '10px 20px' : '14px 28px';
  const fs = size === 'lg' ? '1.2rem' : size === 'sm' ? '0.85rem' : '1rem';

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      style={{
        padding: pads,
        fontSize: fs,
        fontFamily: 'Boogaloo, cursive',
        fontWeight: 400,
        letterSpacing: '0.05em',
        color: '#fff',
        background: disabled ? '#333' : `linear-gradient(135deg, ${color}dd, ${color})`,
        border: `2px solid ${disabled ? '#555' : color}`,
        borderRadius: 50,
        cursor: disabled ? 'not-allowed' : 'pointer',
        boxShadow: disabled ? 'none' : `0 0 15px ${color}88, 0 4px 20px rgba(0,0,0,0.4)`,
        transition: 'all 0.2s',
        userSelect: 'none',
        WebkitTapHighlightColor: 'transparent',
        touchAction: 'manipulation',
        ...style,
      }}
      onTouchStart={e => { if (!disabled) e.currentTarget.style.transform = 'scale(0.95)'; }}
      onTouchEnd={e => { e.currentTarget.style.transform = 'scale(1)'; }}
    >
      {children}
    </button>
  );
}

function Card({ children, style = {}, glow }) {
  return (
    <div style={{
      background: 'rgba(26,26,46,0.9)',
      border: `1px solid ${glow || '#7c4dff'}44`,
      borderRadius: 20,
      padding: 20,
      boxShadow: glow ? `0 0 30px ${glow}22, 0 8px 32px rgba(0,0,0,0.4)` : '0 8px 32px rgba(0,0,0,0.4)',
      backdropFilter: 'blur(10px)',
      ...style,
    }}>
      {children}
    </div>
  );
}

function Confetti() {
  const colors = ['#ff2d78', '#ffd600', '#00e5ff', '#7c4dff', '#00e676'];
  const pieces = Array.from({ length: 40 }, (_, i) => ({
    id: i,
    color: colors[i % colors.length],
    left: Math.random() * 100,
    delay: Math.random() * 2,
    duration: 2 + Math.random() * 3,
    size: 8 + Math.random() * 12,
  }));

  return (
    <div style={{ position: 'fixed', inset: 0, pointerEvents: 'none', zIndex: 999, overflow: 'hidden' }}>
      {pieces.map(p => (
        <div key={p.id} style={{
          position: 'absolute',
          left: `${p.left}%`,
          top: -20,
          width: p.size,
          height: p.size,
          background: p.color,
          borderRadius: Math.random() > 0.5 ? '50%' : 2,
          animation: `confetti-fall ${p.duration}s ${p.delay}s ease-in forwards`,
          opacity: 0,
        }} />
      ))}
    </div>
  );
}

// ─── Screens ──────────────────────────────────────────────────────────────────

function LangSelector() {
  const { lang, setLang } = useLang();
  const langs = [
    { code: 'nl', flag: '🇳🇱', label: 'NL' },
    { code: 'en', flag: '🇬🇧', label: 'EN' },
    { code: 'fr', flag: '🇫🇷', label: 'FR' },
  ];
  return (
    <div style={{ display: 'flex', gap: 6, justifyContent: 'center', marginBottom: 20 }}>
      {langs.map(l => (
        <button
          key={l.code}
          onClick={() => setLang(l.code)}
          style={{
            padding: '5px 12px',
            background: lang === l.code ? 'rgba(124,77,255,0.35)' : 'rgba(255,255,255,0.06)',
            border: `1px solid ${lang === l.code ? '#7c4dff' : 'rgba(255,255,255,0.12)'}`,
            borderRadius: 20,
            color: lang === l.code ? '#fff' : '#8888aa',
            cursor: 'pointer',
            fontSize: '0.8rem',
            fontWeight: lang === l.code ? 700 : 400,
            transition: 'all 0.2s',
          }}
        >
          {l.flag} {l.label}
        </button>
      ))}
    </div>
  );
}

function ModeScreen({ onChooseSpotify, onChooseFree, onChooseMovies }) {
  const { t } = useLang();
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ textAlign: 'center', animation: 'bounce-in 0.6s ease-out', width: '100%', maxWidth: 360 }}>
        <img
          src="/frontendimage.png"
          alt="Beat Detective"
          style={{ width: 220, height: 220, objectFit: 'contain', marginBottom: 8 }}
        />
        <h1 style={{
          fontFamily: 'Boogaloo, cursive',
          fontSize: '3rem',
          background: 'linear-gradient(135deg, #ff2d78, #ffd600, #00e5ff)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          marginBottom: 4,
        }}>Open Hitster</h1>
        <p style={{ color: '#8888aa', fontSize: '1rem', marginBottom: 24 }}>{t.subtitle}</p>

        <LangSelector />

        <h2 style={{ fontFamily: 'Boogaloo, cursive', fontSize: '1.4rem', color: '#fff', marginBottom: 16 }}>{t.chooseMode}</h2>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 28 }}>
          <button
            onClick={onChooseSpotify}
            style={{
              padding: '20px 24px',
              background: 'rgba(29,185,84,0.12)',
              border: '2px solid #1DB954',
              borderRadius: 16,
              color: '#fff',
              cursor: 'pointer',
              textAlign: 'left',
              transition: 'all 0.2s',
            }}
            onMouseEnter={e => e.currentTarget.style.background = 'rgba(29,185,84,0.22)'}
            onMouseLeave={e => e.currentTarget.style.background = 'rgba(29,185,84,0.12)'}
          >
            <div style={{ fontSize: '1.2rem', fontFamily: 'Boogaloo, cursive', color: '#1DB954' }}>{t.modeSpotify}</div>
            <div style={{ fontSize: '0.8rem', color: '#8888aa', marginTop: 4 }}>{t.modeSpotifyDesc}</div>
          </button>

          <button
            onClick={onChooseFree}
            style={{
              padding: '20px 24px',
              background: 'rgba(255,214,0,0.08)',
              border: '2px solid #ffd600',
              borderRadius: 16,
              color: '#fff',
              cursor: 'pointer',
              textAlign: 'left',
              transition: 'all 0.2s',
            }}
            onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,214,0,0.18)'}
            onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,214,0,0.08)'}
          >
            <div style={{ fontSize: '1.2rem', fontFamily: 'Boogaloo, cursive', color: '#ffd600' }}>{t.modeFree}</div>
            <div style={{ fontSize: '0.8rem', color: '#8888aa', marginTop: 4 }}>{t.modeFreeDesc}</div>
          </button>

          <button
            onClick={onChooseMovies}
            style={{
              padding: '20px 24px',
              background: 'rgba(255,100,0,0.08)',
              border: '2px solid #ff6400',
              borderRadius: 16,
              color: '#fff',
              cursor: 'pointer',
              textAlign: 'left',
              transition: 'all 0.2s',
            }}
            onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,100,0,0.18)'}
            onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,100,0,0.08)'}
          >
            <div style={{ fontSize: '1.2rem', fontFamily: 'Boogaloo, cursive', color: '#ff6400' }}>{t.modeMovies}</div>
            <div style={{ fontSize: '0.8rem', color: '#8888aa', marginTop: 4 }}>{t.modeMoviesDesc}</div>
          </button>
        </div>

        <p style={{ fontSize: '0.72rem', color: '#555566', lineHeight: 1.5 }}>
          {t.donateText}{' '}
          <a
            href="https://www.paypal.com/donate?business=jorendebruyne%40gmail.com"
            target="_blank"
            rel="noreferrer"
            style={{ color: '#009cde', textDecoration: 'none', fontWeight: 600 }}
          >
            PayPal
          </a>
        </p>
      </div>
    </div>
  );
}

function LoginScreen({ onBack }) {
  const { t } = useLang();
  const [clientId, setClientId] = useState(() => localStorage.getItem('sp_custom_client_id') || '');
  const [clientSecret, setClientSecret] = useState(() => localStorage.getItem('sp_custom_client_secret') || '');
  const [braveApiKey, setBraveApiKey] = useState(() => localStorage.getItem('brave_api_key') || '');

  const handleLogin = () => {
    localStorage.setItem('sp_custom_client_id', clientId);
    localStorage.setItem('sp_custom_client_secret', clientSecret);
    localStorage.setItem('brave_api_key', braveApiKey);
    window.location.href = `${API}/login?client_id=${encodeURIComponent(clientId)}&client_secret=${encodeURIComponent(clientSecret)}`;
  };

  const inputStyle = {
    width: '100%',
    padding: '10px 14px',
    background: 'rgba(255,255,255,0.07)',
    border: '1px solid rgba(255,255,255,0.15)',
    borderRadius: 10,
    color: '#fff',
    fontSize: '0.9rem',
    outline: 'none',
    boxSizing: 'border-box',
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ textAlign: 'center', animation: 'bounce-in 0.6s ease-out', width: '100%', maxWidth: 360 }}>
        {onBack && (
          <div style={{ textAlign: 'left', marginBottom: 8 }}>
            <button onClick={onBack} style={{ background: 'none', border: 'none', color: '#8888aa', cursor: 'pointer', fontSize: '0.9rem', padding: 0 }}>
              {t.back}
            </button>
          </div>
        )}

        <img
          src="/frontendimage.png"
          alt="Beat Detective"
          style={{ width: 220, height: 220, objectFit: 'contain', marginBottom: 8 }}
        />
        <h1 style={{
          fontFamily: 'Boogaloo, cursive',
          fontSize: '3rem',
          background: 'linear-gradient(135deg, #ff2d78, #ffd600, #00e5ff)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          marginBottom: 8,
        }}>Open Hitster</h1>
        <p style={{ color: '#8888aa', fontSize: '1.1rem', marginBottom: 20 }}>{t.subtitle}</p>

        <LangSelector />

        {/* How it works */}
        <Card style={{ marginBottom: 16, textAlign: 'left' }} glow="#ffd600">
          <div style={{ fontSize: '0.8rem', fontWeight: 700, color: '#ffd600', marginBottom: 10 }}>{t.howItWorksTitle}</div>
          <p style={{ fontSize: '0.75rem', color: '#bbb', margin: '0 0 8px', lineHeight: 1.6 }}>
            <strong style={{ color: '#fff' }}>{t.howItWorksIntro}</strong>
          </p>
          {[
            { icon: '🎵', text: t.howItWorksTips[0] },
            { icon: '📋', text: t.howItWorksTips[1] },
            { icon: '📱', text: t.howItWorksTips[2] },
            { icon: '🎲', text: t.howItWorksTips[3] },
          ].map((item, i) => (
            <div key={i} style={{ display: 'flex', gap: 10, marginBottom: i < 3 ? 8 : 0, alignItems: 'flex-start' }}>
              <span style={{ fontSize: '0.9rem', marginTop: 1 }}>{item.icon}</span>
              <span style={{ fontSize: '0.75rem', color: '#ccc', lineHeight: 1.5 }}>{item.text}</span>
            </div>
          ))}
        </Card>

        {/* API keys */}
        <Card style={{ marginBottom: 16 }} glow="#7c4dff">
          <h3 style={{ fontFamily: 'Boogaloo, cursive', fontSize: '1.1rem', color: '#00e5ff', marginBottom: 12 }}>
            {t.spotifyConnectionTitle}
          </h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <div style={{ background: 'rgba(0,229,255,0.07)', border: '1px solid rgba(0,229,255,0.2)', borderRadius: 12, padding: '12px 14px' }}>
              <div style={{ fontSize: '0.8rem', fontWeight: 700, color: '#00e5ff', marginBottom: 10 }}>{t.spotifyGuideTitle}</div>
              {t.spotifySteps(API).map((text, i) => (
                <div key={i} style={{ display: 'flex', gap: 10, marginBottom: 8, alignItems: 'flex-start' }}>
                  <span style={{ minWidth: 20, height: 20, borderRadius: '50%', background: '#00e5ff22', border: '1px solid #00e5ff55', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.65rem', color: '#00e5ff', fontWeight: 700, marginTop: 1 }}>{i + 1}</span>
                  <span style={{ fontSize: '0.75rem', color: '#ccc', lineHeight: 1.5 }}>{text}</span>
                </div>
              ))}
            </div>

            <input style={inputStyle} placeholder="Client ID" value={clientId} onChange={e => setClientId(e.target.value)} autoComplete="off" />
            <input style={inputStyle} placeholder="Client Secret" type="password" value={clientSecret} onChange={e => setClientSecret(e.target.value)} autoComplete="off" />

            <div style={{ borderTop: '1px solid rgba(255,255,255,0.08)', paddingTop: 12, display: 'flex', flexDirection: 'column', gap: 10 }}>
              <div style={{ fontSize: '0.9rem', fontWeight: 700, color: '#ff9500' }}>{t.braveTitle}</div>
              <p style={{ fontSize: '0.72rem', color: '#8888aa', margin: 0, lineHeight: 1.4 }}>{t.braveDesc}</p>
              <div style={{ background: 'rgba(255,149,0,0.07)', border: '1px solid rgba(255,149,0,0.2)', borderRadius: 12, padding: '12px 14px' }}>
                <div style={{ fontSize: '0.8rem', fontWeight: 700, color: '#ff9500', marginBottom: 10 }}>{t.braveGuideTitle}</div>
                {t.braveSteps.map((text, i) => (
                  <div key={i} style={{ display: 'flex', gap: 10, marginBottom: 8, alignItems: 'flex-start' }}>
                    <span style={{ minWidth: 20, height: 20, borderRadius: '50%', background: '#ff950022', border: '1px solid #ff950055', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.65rem', color: '#ff9500', fontWeight: 700, marginTop: 1 }}>{i + 1}</span>
                    <span style={{ fontSize: '0.75rem', color: '#ccc', lineHeight: 1.5 }}>{text}</span>
                  </div>
                ))}
              </div>
              <input style={inputStyle} placeholder={t.braveKeyPlaceholder} value={braveApiKey} onChange={e => setBraveApiKey(e.target.value)} autoComplete="off" />
            </div>
          </div>
        </Card>

        <NeonButton onClick={handleLogin} disabled={!clientId || !clientSecret || !braveApiKey} color="#1DB954" size="lg">
          {t.loginButton}
        </NeonButton>

        <p style={{ marginTop: 28, fontSize: '0.72rem', color: '#555566', lineHeight: 1.5 }}>
          {t.donateText}{' '}
          <a href="https://www.paypal.com/donate?business=jorendebruyne%40gmail.com" target="_blank" rel="noreferrer" style={{ color: '#009cde', textDecoration: 'none', fontWeight: 600 }}>
            PayPal
          </a>
        </p>
      </div>
    </div>
  );
}

function SetupScreen({ token, onStart }) {
  const { t } = useLang();
  const [playlists, setPlaylists] = useState([]);
  const [devices, setDevices] = useState([]);
  const [selectedPlaylist, setSelectedPlaylist] = useState(null);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [startMode, setStartMode] = useState('begin');
  const [listenDuration, setListenDuration] = useState(0);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);

  useEffect(() => {
    Promise.all([
      fetch(`${API}/me/playlists?token=${token}`).then(r => r.json()),
      fetch(`${API}/me/devices?token=${token}`).then(r => r.json()),
    ]).then(([pl, dv]) => {
      setPlaylists(pl);
      setDevices(dv);
      setLoading(false);
    });
  }, [token]);

  const refreshDevices = async () => {
    setRefreshing(true);
    const dv = await fetch(`${API}/me/devices?token=${token}`).then(r => r.json());
    setDevices(dv);
    setRefreshing(false);
  };

  const canStart = selectedPlaylist && selectedDevice;

  const durationOptions = [
    { label: t.durationFull, value: 0 },
    { label: t.duration30, value: 30 },
    { label: t.duration20, value: 20 },
    { label: t.duration10, value: 10 },
  ];

  if (loading) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 48, animation: 'spin-slow 1s linear infinite' }}>🎵</div>
        <p style={{ color: '#8888aa', marginTop: 16 }}>{t.loading}</p>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', padding: '24px 16px 40px', maxWidth: 480, margin: '0 auto' }}>
      <div style={{ textAlign: 'center', marginBottom: 32, animation: 'slide-up 0.5s ease-out' }}>
        <div style={{ fontSize: 48 }}>🕵️</div>
        <h1 style={{
          fontFamily: 'Boogaloo, cursive',
          fontSize: '2.2rem',
          background: 'linear-gradient(135deg, #ff2d78, #ffd600)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
        }}>{t.settingsTitle}</h1>
      </div>

      <Card style={{ marginBottom: 16 }} glow="#7c4dff">
        <h3 style={{ fontFamily: 'Boogaloo, cursive', fontSize: '1.2rem', color: '#00e5ff', marginBottom: 12 }}>{t.choosePlaylist}</h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, maxHeight: 220, overflowY: 'auto' }}>
          {playlists.map(pl => (
            <button
              key={pl.id}
              onClick={() => setSelectedPlaylist(pl)}
              style={{
                display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px',
                background: selectedPlaylist?.id === pl.id ? 'rgba(124,77,255,0.3)' : 'rgba(255,255,255,0.05)',
                border: `2px solid ${selectedPlaylist?.id === pl.id ? '#7c4dff' : 'transparent'}`,
                borderRadius: 12, cursor: 'pointer', color: '#fff', textAlign: 'left', transition: 'all 0.2s',
              }}
            >
              {pl.images?.[0]?.url
                ? <img src={pl.images[0].url} alt="" style={{ width: 36, height: 36, borderRadius: 6, objectFit: 'cover' }} />
                : <div style={{ width: 36, height: 36, borderRadius: 6, background: '#7c4dff22', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>🎵</div>
              }
              <div>
                <div style={{ fontSize: '0.9rem', fontWeight: 700, lineHeight: 1.2 }}>{pl.name}</div>
                <div style={{ fontSize: '0.75rem', color: '#8888aa' }}>{pl.tracks?.total} {t.tracks}</div>
              </div>
              {selectedPlaylist?.id === pl.id && <span style={{ marginLeft: 'auto', color: '#7c4dff' }}>✓</span>}
            </button>
          ))}
        </div>
      </Card>

      <Card style={{ marginBottom: 16 }} glow="#ff2d78">
        <h3 style={{ fontFamily: 'Boogaloo, cursive', fontSize: '1.2rem', color: '#ff2d78', marginBottom: 12 }}>{t.startPosition}</h3>
        <div style={{ display: 'flex', gap: 8 }}>
          {[
            { v: 'begin', label: t.startBegin, desc: t.startBeginDesc },
            { v: 'random', label: t.startRandom, desc: t.startRandomDesc },
          ].map(opt => (
            <button
              key={opt.v}
              onClick={() => setStartMode(opt.v)}
              style={{
                flex: 1, padding: '12px 8px',
                background: startMode === opt.v ? 'rgba(255,45,120,0.25)' : 'rgba(255,255,255,0.05)',
                border: `2px solid ${startMode === opt.v ? '#ff2d78' : 'transparent'}`,
                borderRadius: 12, color: '#fff', cursor: 'pointer', transition: 'all 0.2s',
              }}
            >
              <div style={{ fontSize: '0.8rem', fontWeight: 700, color: startMode === opt.v ? '#ff2d78' : '#ccc' }}>{opt.label}</div>
              <div style={{ fontSize: '0.7rem', color: '#8888aa', marginTop: 2 }}>{opt.desc}</div>
            </button>
          ))}
        </div>
      </Card>

      <Card style={{ marginBottom: 16 }} glow="#ffd600">
        <h3 style={{ fontFamily: 'Boogaloo, cursive', fontSize: '1.2rem', color: '#ffd600', marginBottom: 12 }}>{t.listenDuration}</h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {durationOptions.map(opt => (
            <button
              key={opt.value}
              onClick={() => setListenDuration(opt.value)}
              style={{
                padding: '10px 16px',
                background: listenDuration === opt.value ? 'rgba(255,214,0,0.2)' : 'rgba(255,255,255,0.05)',
                border: `2px solid ${listenDuration === opt.value ? '#ffd600' : 'transparent'}`,
                borderRadius: 10, color: '#fff', cursor: 'pointer', textAlign: 'left',
                fontWeight: listenDuration === opt.value ? 700 : 400, fontSize: '0.95rem',
                transition: 'all 0.2s', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              }}
            >
              {opt.label}
              {listenDuration === opt.value && <span style={{ color: '#ffd600' }}>✓</span>}
            </button>
          ))}
        </div>
      </Card>

      <Card style={{ marginBottom: 32 }} glow="#00e5ff">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
          <h3 style={{ fontFamily: 'Boogaloo, cursive', fontSize: '1.2rem', color: '#00e5ff' }}>{t.deviceTitle}</h3>
          <button onClick={refreshDevices} style={{ background: 'none', border: 'none', color: '#8888aa', cursor: 'pointer', fontSize: '1.2rem', animation: refreshing ? 'spin-slow 1s linear infinite' : 'none' }}>🔄</button>
        </div>
        {devices.length === 0
          ? <div style={{ color: '#8888aa', fontSize: '0.9rem', textAlign: 'center', padding: '16px 0' }}>
              {t.noDevices}<br />
              <span style={{ fontSize: '0.8rem' }}>{t.noDevicesHint}</span>
              <div style={{ marginTop: 12 }}>
                <button onClick={() => { window.location.href = 'spotify:'; setTimeout(refreshDevices, 3000); }} style={{ padding: '8px 20px', background: 'linear-gradient(135deg, #1DB954dd, #1DB954)', border: '2px solid #1DB954', borderRadius: 50, color: '#fff', fontSize: '0.85rem', cursor: 'pointer', fontFamily: 'Boogaloo, cursive' }}>
                  {t.openSpotify}
                </button>
              </div>
            </div>
          : devices.map(d => (
            <button
              key={d.id}
              onClick={() => setSelectedDevice(d)}
              style={{
                width: '100%', padding: '10px 14px', marginBottom: 6,
                background: selectedDevice?.id === d.id ? 'rgba(0,229,255,0.2)' : 'rgba(255,255,255,0.05)',
                border: `2px solid ${selectedDevice?.id === d.id ? '#00e5ff' : 'transparent'}`,
                borderRadius: 10, color: '#fff', cursor: 'pointer', textAlign: 'left',
                display: 'flex', alignItems: 'center', gap: 10, transition: 'all 0.2s',
              }}
            >
              <span style={{ fontSize: '1.3rem' }}>
                {d.type === 'Smartphone' ? '📱' : d.type === 'Computer' ? '💻' : d.type === 'Speaker' ? '🔊' : '📺'}
              </span>
              <div>
                <div style={{ fontSize: '0.9rem', fontWeight: 700 }}>{d.name}</div>
                <div style={{ fontSize: '0.75rem', color: '#8888aa' }}>{d.type}{d.is_active ? ` · ${t.active}` : ''}</div>
              </div>
              {selectedDevice?.id === d.id && <span style={{ marginLeft: 'auto', color: '#00e5ff' }}>✓</span>}
            </button>
          ))
        }
      </Card>

      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <NeonButton onClick={() => onStart({ playlist: selectedPlaylist, device: selectedDevice, startMode, listenDuration })} disabled={!canStart} color="#ff2d78" size="lg">
          {t.startGame}
        </NeonButton>
      </div>
    </div>
  );
}

function GameScreen({ token, settings, onBack }) {
  const { t } = useLang();
  const [tracks, setTracks] = useState([]);
  const [queue, setQueue] = useState([]);
  const [trackIndex, setTrackIndex] = useState(0);
  const [playlistRestarted, setPlaylistRestarted] = useState(false);
  const [currentTrack, setCurrentTrack] = useState(null);
  const [phase, setPhase] = useState('loading');
  const [revealData, setRevealData] = useState(null);
  const [loadingReveal, setLoadingReveal] = useState(false);
  const [timeLeft, setTimeLeft] = useState(null);
  const [showConfetti, setShowConfetti] = useState(false);
  const [round, setRound] = useState(1);
  const timerRef = useRef(null);

  useEffect(() => {
    fetch(`${API}/playlists/${settings.playlist.id}/tracks?token=${token}`)
      .then(r => r.json())
      .then(tr => {
        setTracks(tr);
        setQueue(shuffle([...tr]));
        setTrackIndex(0);
        setPhase('ready');
      });
  }, [token, settings.playlist.id]);

  const playNext = useCallback(async () => {
    if (!queue.length) return;

    clearInterval(timerRef.current);

    const q = queue;
    const idx = trackIndex;
    const all = tracks;

    let nextQueue = q;
    let nextIndex = idx;
    let restarted = false;

    if (nextIndex >= nextQueue.length) {
      nextQueue = shuffle([...all]);
      nextIndex = 0;
      restarted = true;
    }

    const track = nextQueue[nextIndex];
    setQueue(nextQueue);
    setTrackIndex(nextIndex + 1);
    setCurrentTrack(track);
    setRevealData(null);

    if (restarted) {
      setPlaylistRestarted(true);
      setTimeout(() => setPlaylistRestarted(false), 3000);
    }

    const position_ms = settings.startMode === 'random'
      ? Math.floor(Math.random() * (track.duration_ms * 0.6))
      : 0;

    const deviceId = settings.device.id;

    await fetch(`${API}/play`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token, device_id: deviceId, track_uri: `spotify:track:${track.id}`, position_ms }) });

    setPhase('playing');

    if (settings.listenDuration > 0) {
      const tok = token;
      setTimeLeft(settings.listenDuration);
      let remaining = settings.listenDuration;
      timerRef.current = setInterval(() => {
        remaining--;
        setTimeLeft(remaining);
        if (remaining <= 0) {
          clearInterval(timerRef.current);
          fetch(`${API}/pause`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token: tok, device_id: deviceId }) });
          setPhase('stopped');
        }
      }, 1000);
    }
  }, [queue, trackIndex, tracks, settings, token]);

  const stopPlayback = async () => {
    clearInterval(timerRef.current);
    await fetch(`${API}/pause`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token, device_id: settings.device.id }) });
  };

  const handleReveal = async () => {
    clearInterval(timerRef.current);
    await stopPlayback();
    setLoadingReveal(true);

    const artist = currentTrack.artists.map(a => a.name).join(', ');
    const spotifyYear = currentTrack.album.release_date?.substring(0, 4) || '?';
    const braveKey = localStorage.getItem('brave_api_key') || '';

    const res = await fetch(`${API}/release-year`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ artist, track: currentTrack.name, spotify_year: spotifyYear, brave_api_key: braveKey }),
    }).then(r => r.json());

    setRevealData({ artist, name: currentTrack.name, year: res.year, albumArt: currentTrack.album.images?.[0]?.url });
    setShowConfetti(true);
    setTimeout(() => setShowConfetti(false), 4000);
    setLoadingReveal(false);
    setPhase('revealed');
  };

  const nextRound = () => {
    setRound(r => r + 1);
    playNext();
  };

  if (phase === 'loading') return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 48, animation: 'spin-slow 1s linear infinite' }}>🎵</div>
        <p style={{ color: '#8888aa', marginTop: 12 }}>{t.loadingPlaylist}</p>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', padding: '24px 16px 40px', maxWidth: 480, margin: '0 auto' }}>
      {showConfetti && <Confetti />}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
        <button onClick={() => { stopPlayback(); onBack(); }} style={{ background: 'none', border: 'none', color: '#8888aa', cursor: 'pointer', fontSize: '1.5rem', padding: 4 }}>←</button>
        <div style={{ fontFamily: 'Boogaloo, cursive', fontSize: '1.4rem', color: '#ffd600' }}>{t.round(round)}</div>
        <div style={{ width: 32 }} />
      </div>

      {playlistRestarted && <div style={{ textAlign: 'center', color: '#ffd600', fontSize: '0.85rem', marginBottom: 12 }}>{t.playlistRestarted}</div>}

      <Card glow="#ff2d78" style={{ textAlign: 'center', marginBottom: 20, padding: '32px 20px' }}>
        {phase === 'ready' && (
          <div style={{ animation: 'bounce-in 0.5s ease-out' }}>
            <div style={{ fontSize: 80, marginBottom: 16, animation: 'float 3s ease-in-out infinite' }}>🎵</div>
            <p style={{ color: '#ccc', marginBottom: 24 }}>{t.readyToStart}</p>
            <NeonButton onClick={() => playNext()} color="#ff2d78" size="lg">{t.startFirst}</NeonButton>
          </div>
        )}

        {(phase === 'playing' || phase === 'stopped') && !revealData && (
          <div style={{ animation: 'bounce-in 0.4s ease-out' }}>
            <div style={{
              width: 120, height: 120, borderRadius: '50%',
              background: 'radial-gradient(circle, #333 30%, #111 70%)',
              margin: '0 auto 20px', border: '4px solid #ff2d78',
              animation: phase === 'playing' ? 'spin-slow 3s linear infinite' : 'none',
              boxShadow: phase === 'playing' ? '0 0 30px #ff2d7855' : 'none',
              display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 32,
            }}>🎵</div>
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 16 }}>
              <Equalizer playing={phase === 'playing'} />
            </div>
            <p style={{ color: '#8888aa', marginBottom: 8, fontSize: '0.9rem' }}>
              {phase === 'playing' ? t.musicPlaying : t.stoppedAfterTimer}
            </p>
            {timeLeft !== null && phase === 'playing' && (
              <div style={{ fontSize: '2rem', fontFamily: 'Boogaloo, cursive', color: timeLeft <= 5 ? '#ff2d78' : '#ffd600', transition: 'color 0.3s' }}>
                {timeLeft}s
              </div>
            )}
          </div>
        )}

        {phase === 'revealed' && revealData && (
          <div style={{ animation: 'bounce-in 0.5s ease-out' }}>
            {revealData.albumArt && (
              <img src={revealData.albumArt} alt="Album art" style={{ width: 140, height: 140, borderRadius: 16, objectFit: 'cover', marginBottom: 16, border: '3px solid #ffd600', boxShadow: '0 0 30px #ffd60055', animation: 'float 3s ease-in-out infinite' }} />
            )}
            <div style={{ fontFamily: 'Boogaloo, cursive', fontSize: '1.8rem', color: '#ffd600', marginBottom: 4 }}>{revealData.name}</div>
            <div style={{ fontSize: '1rem', color: '#00e5ff', marginBottom: 8, fontWeight: 700 }}>🎤 {revealData.artist}</div>
            <div style={{ display: 'inline-block', background: 'linear-gradient(135deg, #ff2d78, #7c4dff)', borderRadius: 20, padding: '4px 16px', fontFamily: 'Boogaloo, cursive', fontSize: '1.2rem', letterSpacing: '0.05em' }}>
              📅 {revealData.year}
            </div>
          </div>
        )}
      </Card>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 12, alignItems: 'center' }}>
        {(phase === 'playing' || phase === 'stopped') && (
          <NeonButton onClick={handleReveal} disabled={loadingReveal} color="#ffd600" size="lg" style={{ width: '100%', maxWidth: 320 }}>
            {loadingReveal ? t.searching : t.reveal}
          </NeonButton>
        )}
        {phase === 'revealed' && (
          <NeonButton onClick={nextRound} color="#00e676" size="lg" style={{ width: '100%', maxWidth: 320 }}>{t.nextTrack}</NeonButton>
        )}
        {phase === 'playing' && (
          <NeonButton onClick={() => { stopPlayback(); setPhase('stopped'); clearInterval(timerRef.current); setTimeLeft(null); }} color="#7c4dff" size="sm">
            {t.pause}
          </NeonButton>
        )}
      </div>

      <div style={{ marginTop: 32, display: 'flex', gap: 8, flexWrap: 'wrap', justifyContent: 'center' }}>
        {[
          `🎼 ${settings.playlist.name}`,
          settings.startMode === 'random' ? t.randomStart : t.beginStart,
          settings.listenDuration === 0 ? t.fullTrack : `⏱ ${settings.listenDuration}s`,
          `📱 ${settings.device.name}`,
        ].map(tag => (
          <span key={tag} style={{ background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 20, padding: '4px 12px', fontSize: '0.75rem', color: '#8888aa' }}>{tag}</span>
        ))}
      </div>
    </div>
  );
}

// ─── Free path ────────────────────────────────────────────────────────────────

function FreeSetupScreen({ onStart, onBack }) {
  const { t } = useLang();
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const [searchOffset, setSearchOffset] = useState(0);
  const [lastQuery, setLastQuery] = useState('');
  const [selectedPlaylist, setSelectedPlaylist] = useState(null);
  const [enriching, setEnriching] = useState(false);
  const [enrichedTracks, setEnrichedTracks] = useState(null);
  const [startMode, setStartMode] = useState('begin');
  const [listenDuration, setListenDuration] = useState(30);
  const [revealVideo, setRevealVideo] = useState(true);
  const [hintMode, setHintMode] = useState('off');

  const doSearch = async () => {
    if (!query.trim()) return;
    setIsSearching(true);
    setResults([]);
    setSelectedPlaylist(null);
    setEnrichedTracks(null);
    setHasMore(false);
    setSearchOffset(0);
    setLastQuery(query.trim());

    const directId = parseDeezerInput(query.trim());
    if (directId) {
      setIsSearching(false);
      await selectPlaylist({ id: directId, title: query.trim(), trackCount: '?', image: null });
      return;
    }

    try {
      const res = await fetch(`${API}/deezer/search?q=${encodeURIComponent(query.trim())}&index=0`).then(r => r.json());
      setResults(res.results || []);
      setHasMore(res.hasMore || false);
      setSearchOffset(50);
    } catch {}
    setIsSearching(false);
  };

  const loadMore = async () => {
    if (isSearching || !hasMore) return;
    setIsSearching(true);
    try {
      const res = await fetch(`${API}/deezer/search?q=${encodeURIComponent(lastQuery)}&index=${searchOffset}`).then(r => r.json());
      setResults(prev => [...prev, ...(res.results || [])]);
      setHasMore(res.hasMore || false);
      setSearchOffset(prev => prev + 50);
    } catch {}
    setIsSearching(false);
  };

  const selectPlaylist = async (pl) => {
    setSelectedPlaylist(pl);
    setResults([]);
    setEnrichedTracks(null);
    setEnriching(true);
    try {
      const data = await fetch(`${API}/deezer/playlist/${pl.id}`).then(r => r.json());
      setSelectedPlaylist(prev => ({ ...prev, title: data.title || prev.title, trackCount: data.trackCount || prev.trackCount, image: data.image || prev.image }));
      setEnrichedTracks(data.tracks || []);
    } catch {
      setEnrichedTracks([]);
    }
    setEnriching(false);
  };

  const inputStyle = {
    flex: 1,
    padding: '10px 14px',
    background: 'rgba(255,255,255,0.07)',
    border: '1px solid rgba(255,255,255,0.15)',
    borderRadius: 10,
    color: '#fff',
    fontSize: '0.9rem',
    outline: 'none',
  };

  const durationOptions = [
    { label: t.durationFull, value: 0 },
    { label: t.duration30, value: 30 },
    { label: t.duration20, value: 20 },
    { label: t.duration10, value: 10 },
  ];

  const hintOptions = [
    { v: 'off', label: t.hintOff, desc: t.hintOffDesc },
    { v: 'peek', label: t.hintPeek, desc: t.hintPeekDesc },
    { v: 'full', label: t.hintFull, desc: t.hintFullDesc },
  ];

  return (
    <div style={{ minHeight: '100vh', padding: '24px 16px 40px', maxWidth: 480, margin: '0 auto' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 24 }}>
        <button onClick={onBack} style={{ background: 'none', border: 'none', color: '#8888aa', cursor: 'pointer', fontSize: '1.5rem', padding: 4 }}>←</button>
        <h1 style={{ fontFamily: 'Boogaloo, cursive', fontSize: '1.8rem', color: '#ffd600', margin: 0 }}>{t.deezerSearchTitle}</h1>
      </div>

      {/* Search */}
      <Card style={{ marginBottom: 16 }} glow="#ffd600">
        <div style={{ display: 'flex', gap: 8 }}>
          <input
            style={inputStyle}
            placeholder={t.searchPlaceholder}
            value={query}
            onChange={e => setQuery(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && doSearch()}
          />
          <NeonButton onClick={doSearch} disabled={isSearching || !query.trim()} color="#ffd600" size="sm">
            {isSearching ? '...' : t.searchBtn}
          </NeonButton>
        </div>
        <p style={{ fontSize: '0.72rem', color: '#8888aa', margin: '8px 0 0', textAlign: 'center' }}>{t.pasteHint}</p>
      </Card>

      {/* Search results */}
      {results.length > 0 && (
        <Card style={{ marginBottom: 16 }} glow="#00e5ff">
          <div
            style={{ display: 'flex', flexDirection: 'column', gap: 8, maxHeight: 280, overflowY: 'auto' }}
            onScroll={e => {
              const el = e.currentTarget;
              if (el.scrollHeight - el.scrollTop - el.clientHeight < 80) loadMore();
            }}
          >
            {results.map(pl => (
              <button
                key={pl.id}
                onClick={() => selectPlaylist(pl)}
                style={{
                  display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px',
                  background: 'rgba(255,255,255,0.05)', border: '2px solid transparent',
                  borderRadius: 12, cursor: 'pointer', color: '#fff', textAlign: 'left', transition: 'all 0.2s',
                }}
              >
                {pl.image
                  ? <img src={pl.image} alt="" style={{ width: 40, height: 40, borderRadius: 8, objectFit: 'cover' }} />
                  : <div style={{ width: 40, height: 40, borderRadius: 8, background: '#ffd60022', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>🎵</div>
                }
                <div>
                  <div style={{ fontSize: '0.9rem', fontWeight: 700, lineHeight: 1.2 }}>{pl.title}</div>
                  <div style={{ fontSize: '0.75rem', color: '#8888aa' }}>{pl.trackCount} {t.tracks} · {pl.owner}</div>
                </div>
              </button>
            ))}
            {hasMore && (
              <div style={{ textAlign: 'center', padding: '8px 0', fontSize: '0.8rem', color: '#8888aa' }}>
                {isSearching ? '⏳ laden...' : '↓ scroll voor meer'}
              </div>
            )}
          </div>
        </Card>
      )}

      {results.length === 0 && !isSearching && query && !selectedPlaylist && (
        <p style={{ textAlign: 'center', color: '#8888aa', fontSize: '0.85rem', marginBottom: 16 }}>{t.noResults}</p>
      )}

      {/* Selected playlist */}
      {selectedPlaylist && (
        <Card style={{ marginBottom: 16 }} glow="#00e5ff">
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            {selectedPlaylist.image
              ? <img src={selectedPlaylist.image} alt="" style={{ width: 52, height: 52, borderRadius: 10, objectFit: 'cover' }} />
              : <div style={{ width: 52, height: 52, borderRadius: 10, background: '#00e5ff22', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24 }}>🎵</div>
            }
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 700, fontSize: '0.95rem' }}>{selectedPlaylist.title}</div>
              {enriching && (
                <div style={{ fontSize: '0.8rem', color: '#ffd600', animation: 'pulse 1s ease-in-out infinite' }}>⏳ {t.loading}</div>
              )}
              {!enriching && enrichedTracks && (
                <div style={{ fontSize: '0.8rem', color: '#00e5ff' }}>{enrichedTracks.length} {t.tracks} ✓</div>
              )}
            </div>
            <button onClick={() => { setSelectedPlaylist(null); setEnrichedTracks(null); setResults([]); }} style={{ background: 'none', border: 'none', color: '#8888aa', cursor: 'pointer', fontSize: '1.2rem', padding: 4 }}>✕</button>
          </div>
        </Card>
      )}

      {enrichedTracks && enrichedTracks.length > 0 && (
        <>
          {/* Start mode */}
          <Card style={{ marginBottom: 16 }} glow="#ff2d78">
            <h3 style={{ fontFamily: 'Boogaloo, cursive', fontSize: '1.2rem', color: '#ff2d78', marginBottom: 12 }}>{t.startPosition}</h3>
            <div style={{ display: 'flex', gap: 8 }}>
              {[{ v: 'begin', label: t.startBegin, desc: t.startBeginDesc }, { v: 'random', label: t.startRandom, desc: t.startRandomDesc }].map(opt => (
                <button key={opt.v} onClick={() => setStartMode(opt.v)} style={{ flex: 1, padding: '12px 8px', background: startMode === opt.v ? 'rgba(255,45,120,0.25)' : 'rgba(255,255,255,0.05)', border: `2px solid ${startMode === opt.v ? '#ff2d78' : 'transparent'}`, borderRadius: 12, color: '#fff', cursor: 'pointer', transition: 'all 0.2s' }}>
                  <div style={{ fontSize: '0.8rem', fontWeight: 700, color: startMode === opt.v ? '#ff2d78' : '#ccc' }}>{opt.label}</div>
                  <div style={{ fontSize: '0.7rem', color: '#8888aa', marginTop: 2 }}>{opt.desc}</div>
                </button>
              ))}
            </div>
          </Card>

          {/* Duration */}
          <Card style={{ marginBottom: 16 }} glow="#ffd600">
            <h3 style={{ fontFamily: 'Boogaloo, cursive', fontSize: '1.2rem', color: '#ffd600', marginBottom: 12 }}>{t.listenDuration}</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {durationOptions.map(opt => (
                <button key={opt.value} onClick={() => setListenDuration(opt.value)} style={{ padding: '10px 16px', background: listenDuration === opt.value ? 'rgba(255,214,0,0.2)' : 'rgba(255,255,255,0.05)', border: `2px solid ${listenDuration === opt.value ? '#ffd600' : 'transparent'}`, borderRadius: 10, color: '#fff', cursor: 'pointer', textAlign: 'left', fontWeight: listenDuration === opt.value ? 700 : 400, fontSize: '0.95rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', transition: 'all 0.2s' }}>
                  {opt.label}
                  {listenDuration === opt.value && <span style={{ color: '#ffd600' }}>✓</span>}
                </button>
              ))}
            </div>
          </Card>

          {/* Video settings */}
          <Card style={{ marginBottom: 24 }} glow="#7c4dff">
            <h3 style={{ fontFamily: 'Boogaloo, cursive', fontSize: '1.2rem', color: '#7c4dff', marginBottom: 12 }}>{t.videoSettingsTitle}</h3>

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
              <span style={{ fontSize: '0.9rem', color: '#ccc' }}>{t.revealVideoLabel}</span>
              <button onClick={() => setRevealVideo(v => !v)} style={{ width: 48, height: 26, background: revealVideo ? '#7c4dff' : 'rgba(255,255,255,0.1)', border: `2px solid ${revealVideo ? '#7c4dff' : 'rgba(255,255,255,0.2)'}`, borderRadius: 13, cursor: 'pointer', position: 'relative', transition: 'all 0.2s' }}>
                <div style={{ position: 'absolute', top: 2, left: revealVideo ? 22 : 2, width: 18, height: 18, borderRadius: '50%', background: '#fff', transition: 'left 0.2s' }} />
              </button>
            </div>

            <div style={{ fontSize: '0.85rem', color: '#ccc', marginBottom: 8 }}>{t.hintModeTitle}</div>
            <div style={{ display: 'flex', gap: 8 }}>
              {hintOptions.map(opt => (
                <button key={opt.v} onClick={() => setHintMode(opt.v)} style={{ flex: 1, padding: '10px 6px', background: hintMode === opt.v ? 'rgba(124,77,255,0.25)' : 'rgba(255,255,255,0.05)', border: `2px solid ${hintMode === opt.v ? '#7c4dff' : 'transparent'}`, borderRadius: 10, color: '#fff', cursor: 'pointer', transition: 'all 0.2s' }}>
                  <div style={{ fontSize: '0.8rem', fontWeight: 700, color: hintMode === opt.v ? '#7c4dff' : '#ccc' }}>{opt.label}</div>
                  <div style={{ fontSize: '0.65rem', color: '#8888aa', marginTop: 2 }}>{opt.desc}</div>
                </button>
              ))}
            </div>
          </Card>

          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <NeonButton
              onClick={() => onStart({ tracks: enrichedTracks, startMode, listenDuration, revealVideo, hintMode, playlistName: selectedPlaylist.title })}
              disabled={enriching}
              color="#ffd600"
              size="lg"
            >
              {t.startFreeGame}
            </NeonButton>
          </div>
        </>
      )}
    </div>
  );
}

function FreeGameScreen({ settings, onBack }) {
  const { t } = useLang();
  const [queue, setQueue] = useState(() => shuffle([...settings.tracks]));
  const [trackIndex, setTrackIndex] = useState(0);
  const [currentTrack, setCurrentTrack] = useState(null);
  const [currentYear, setCurrentYear] = useState(null);
  const [phase, setPhase] = useState('ready');
  const [videoState, setVideoState] = useState('idle'); // 'idle' | 'loading' | 'error' | 'ready'
  const [timeLeft, setTimeLeft] = useState(null);
  const [showConfetti, setShowConfetti] = useState(false);
  const [round, setRound] = useState(1);
  const [playlistRestarted, setPlaylistRestarted] = useState(false);
  const yearPromiseRef = useRef(null);

  const ytPlayerRef = useRef(null);
  const ytApiReadyRef = useRef(false);
  const pendingVideoIdRef = useRef(null);
  const pendingMuteRef = useRef(true);
  const audioRef = useRef(null);
  const timerRef = useRef(null);
  const queueRef = useRef(queue);
  const trackIndexRef = useRef(trackIndex);
  const phaseRef = useRef('ready');

  queueRef.current = queue;
  trackIndexRef.current = trackIndex;
  phaseRef.current = phase;

  const initYTPlayer = () => {
    if (ytPlayerRef.current) return;
    ytPlayerRef.current = new window.YT.Player('yt-player-div', {
      width: '100%',
      height: '100%',
      playerVars: { autoplay: 1, controls: 0, modestbranding: 1, rel: 0, iv_load_policy: 3 },
      events: {
        onReady: () => {
          ytApiReadyRef.current = true;
          if (pendingMuteRef.current) { ytPlayerRef.current.mute(); } else { ytPlayerRef.current.unMute(); }
          if (pendingVideoIdRef.current) {
            ytPlayerRef.current.loadVideoById(pendingVideoIdRef.current);
            pendingVideoIdRef.current = null;
          }
        },
      },
    });
  };

  useEffect(() => {
    if (window.YT && window.YT.Player) {
      ytApiReadyRef.current = true;
      setTimeout(initYTPlayer, 0); // defer so div is in DOM
      return;
    }
    const prev = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = () => {
      if (prev) prev();
      initYTPlayer();
    };
    if (!document.getElementById('yt-api-script')) {
      const s = document.createElement('script');
      s.id = 'yt-api-script';
      s.src = 'https://www.youtube.com/iframe_api';
      document.head.appendChild(s);
    }
    return () => {
      clearInterval(timerRef.current);
      if (audioRef.current) { audioRef.current.pause(); audioRef.current.src = ''; }
      try { ytPlayerRef.current?.destroy(); } catch {}
    };
  }, []);

  const startTimer = (onStop) => {
    if (settings.listenDuration <= 0) return;
    setTimeLeft(settings.listenDuration);
    let remaining = settings.listenDuration;
    timerRef.current = setInterval(() => {
      remaining--;
      setTimeLeft(remaining);
      if (remaining <= 0) {
        clearInterval(timerRef.current);
        onStop();
      }
    }, 1000);
  };

  const fetchYear = (track) => {
    const braveKey = localStorage.getItem('brave_api_key') || '';
    return fetch(`${API}/deezer/enrich`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ tracks: [track], brave_api_key: braveKey }),
    })
      .then(r => r.json())
      .then(res => res?.[0]?.releaseYear || '?')
      .catch(() => '?');
  };

  const loadTrack = async (track) => {
    clearInterval(timerRef.current);
    if (audioRef.current) { audioRef.current.pause(); audioRef.current.src = ''; }
    setCurrentTrack(track);
    setCurrentYear(null);
    yearPromiseRef.current = fetchYear(track);
    setVideoState('loading');
    setTimeLeft(null);

    const hasDeezerPreview = !!track.preview;

    if (hasDeezerPreview) {
      // Deezer preview beschikbaar: speel direct af, start timer meteen
      audioRef.current.src = track.preview;
      audioRef.current.play().catch(() => {});
      setPhase('playing');
      startTimer(() => {
        if (audioRef.current) audioRef.current.pause();
        try { ytPlayerRef.current?.pauseVideo(); } catch {}
        setPhase('stopped');
      });
    } else {
      // Geen preview: YouTube wordt audio + video (ongedempt)
      setPhase('loading-video');
    }

    // YouTube laden: gedempt als Deezer beschikbaar, ongedempt als fallback
    try {
      const res = await fetch(`${API}/youtube/video?artist=${encodeURIComponent(track.artist)}&title=${encodeURIComponent(track.title)}`);
      if (!res.ok) {
        setVideoState(res.status === 503 ? 'missing-key' : 'error');
        if (!hasDeezerPreview) { setPhase('playing'); startTimer(() => setPhase('stopped')); }
        return;
      }
      const { videoId } = await res.json();
      setVideoState('ready');
      pendingMuteRef.current = hasDeezerPreview;
      if (ytPlayerRef.current && ytApiReadyRef.current) {
        if (hasDeezerPreview) { ytPlayerRef.current.mute(); } else { ytPlayerRef.current.unMute(); }
        ytPlayerRef.current.loadVideoById(videoId);
      } else {
        pendingVideoIdRef.current = videoId;
      }
      if (!hasDeezerPreview) {
        setPhase('playing');
        startTimer(() => { try { ytPlayerRef.current?.pauseVideo(); } catch {} setPhase('stopped'); });
      }
    } catch {
      setVideoState('error');
      if (!hasDeezerPreview) { setPhase('playing'); startTimer(() => setPhase('stopped')); }
    }
  };

  const playNext = () => {
    let q = queueRef.current;
    let idx = trackIndexRef.current;
    let restarted = false;

    if (idx >= q.length) {
      q = shuffle([...settings.tracks]);
      idx = 0;
      restarted = true;
      setQueue(q);
    }
    setTrackIndex(idx + 1);

    if (restarted) {
      setPlaylistRestarted(true);
      setTimeout(() => setPlaylistRestarted(false), 3000);
    }
    loadTrack(q[idx]);
  };

  const handleReveal = async () => {
    clearInterval(timerRef.current);
    if (audioRef.current) audioRef.current.pause();
    try { ytPlayerRef.current?.pauseVideo(); } catch {}
    setShowConfetti(true);
    setTimeout(() => setShowConfetti(false), 4000);
    setPhase('revealed');
    const year = await (yearPromiseRef.current ?? Promise.resolve('?'));
    setCurrentYear(year);
  };

  const nextRound = () => {
    setRound(r => r + 1);
    playNext();
  };

  // Overlay logic
  const videoVisible =
    (phase === 'revealed' && settings.revealVideo) ||
    ((phase === 'playing' || phase === 'stopped') && settings.hintMode === 'full');
  const videoPeek = (phase === 'playing' || phase === 'stopped') && settings.hintMode === 'peek' && !videoVisible;

  return (
    <div style={{ minHeight: '100vh', padding: '16px 16px 40px', maxWidth: 480, margin: '0 auto' }}>
      {showConfetti && <Confetti />}
      <audio
        ref={audioRef}
        style={{ display: 'none' }}
        onEnded={() => {
          if (phaseRef.current === 'playing') {
            clearInterval(timerRef.current);
            try { ytPlayerRef.current?.pauseVideo(); } catch {}
            setPhase('stopped');
            setTimeLeft(null);
          }
        }}
      />

      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
        <button
          onClick={() => { clearInterval(timerRef.current); if (audioRef.current) audioRef.current.pause(); try { ytPlayerRef.current?.pauseVideo(); } catch {} onBack(); }}
          style={{ background: 'none', border: 'none', color: '#8888aa', cursor: 'pointer', fontSize: '1.5rem', padding: 4 }}
        >←</button>
        <div style={{ fontFamily: 'Boogaloo, cursive', fontSize: '1.4rem', color: '#ffd600' }}>{t.round(round)}</div>
        <div style={{ width: 32 }} />
      </div>

      {playlistRestarted && <div style={{ textAlign: 'center', color: '#ffd600', fontSize: '0.85rem', marginBottom: 8 }}>{t.playlistRestarted}</div>}

      {/* YouTube player + overlay */}
      <div style={{ position: 'relative', width: '100%', paddingTop: '56.25%', marginBottom: 12, borderRadius: 14, overflow: 'hidden', background: '#000' }}>
        <div id="yt-player-div" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', pointerEvents: videoVisible ? 'auto' : 'none' }} />

        {/* Overlay */}
        <div style={{
          position: 'absolute', inset: 0, borderRadius: 14,
          background: videoVisible ? 'transparent' : (videoPeek ? 'rgba(0,0,0,0.55)' : 'rgba(0,0,0,0.94)'),
          backdropFilter: videoPeek ? 'blur(14px)' : 'none',
          transition: 'background 0.4s, backdrop-filter 0.4s',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          pointerEvents: videoVisible ? 'none' : 'auto',
          touchAction: 'pan-y',
        }}>
          {phase === 'ready' && <div style={{ fontSize: 52 }}>🎬</div>}
          {phase === 'loading-video' && (
            <div style={{ textAlign: 'center', color: '#8888aa' }}>
              <div style={{ fontSize: 32, animation: 'spin-slow 1s linear infinite' }}>⏳</div>
              <div style={{ fontSize: '0.78rem', marginTop: 6 }}>{t.videoLoading}</div>
            </div>
          )}
          {(phase === 'playing' || phase === 'stopped') && !videoVisible && videoState === 'error' && (
            <div style={{ textAlign: 'center', color: '#ff2d78', fontSize: '0.8rem' }}>
              <div style={{ fontSize: 32 }}>⚠️</div>
              <div style={{ marginTop: 4 }}>{t.videoError}</div>
            </div>
          )}
          {(phase === 'playing' || phase === 'stopped') && !videoVisible && videoState === 'missing-key' && (
            <div style={{ textAlign: 'center', color: '#ffd600', fontSize: '0.78rem', padding: '0 12px' }}>
              <div style={{ fontSize: 28 }}>🔑</div>
              <div style={{ marginTop: 4 }}>{t.ytApiMissing}</div>
            </div>
          )}
          {(phase === 'playing' || phase === 'stopped') && !videoVisible && (videoState === 'ready') && (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Equalizer playing={phase === 'playing'} />
            </div>
          )}
        </div>
      </div>

      {/* Info card */}
      <Card glow="#ff2d78" style={{ textAlign: 'center', marginBottom: 16, padding: '20px' }}>
        {phase === 'ready' && (
          <div>
            <div style={{ fontSize: 56, marginBottom: 10, animation: 'float 3s ease-in-out infinite' }}>🎵</div>
            <p style={{ color: '#ccc', marginBottom: 16 }}>{t.readyToStart}</p>
            <NeonButton onClick={playNext} color="#ff2d78" size="lg">{t.startFirst}</NeonButton>
          </div>
        )}

        {(phase === 'playing' || phase === 'stopped' || phase === 'loading-video') && currentTrack && (
          <div>
            <p style={{ color: '#8888aa', fontSize: '0.85rem', marginBottom: 6 }}>
              {phase === 'loading-video' ? t.videoLoading : phase === 'playing' ? t.musicPlaying : t.stoppedAfterTimer}
            </p>
            {timeLeft !== null && phase === 'playing' && (
              <div style={{ fontSize: '2rem', fontFamily: 'Boogaloo, cursive', color: timeLeft <= 5 ? '#ff2d78' : '#ffd600' }}>
                {timeLeft}s
              </div>
            )}
          </div>
        )}

        {phase === 'revealed' && currentTrack && (
          <div style={{ animation: 'bounce-in 0.5s ease-out' }}>
            {currentTrack.album && (
              <div style={{ width: 100, height: 100, borderRadius: 12, background: '#ff2d7822', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px', fontSize: 36 }}>🎵</div>
            )}
            <div style={{ fontFamily: 'Boogaloo, cursive', fontSize: '1.6rem', color: '#ffd600', marginBottom: 4, lineHeight: 1.2 }}>{currentTrack.title}</div>
            <div style={{ fontSize: '0.95rem', color: '#00e5ff', marginBottom: 8, fontWeight: 700 }}>🎤 {currentTrack.artist}</div>
            <div style={{ display: 'inline-block', background: 'linear-gradient(135deg, #ff2d78, #7c4dff)', borderRadius: 20, padding: '4px 16px', fontFamily: 'Boogaloo, cursive', fontSize: '1.2rem' }}>
              📅 {currentYear ?? '...'}
            </div>
          </div>
        )}
      </Card>

      {/* Actions */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, alignItems: 'center' }}>
        {(phase === 'playing' || phase === 'stopped') && (
          <NeonButton onClick={handleReveal} color="#ffd600" size="lg" style={{ width: '100%', maxWidth: 320 }}>{t.reveal}</NeonButton>
        )}
        {phase === 'revealed' && (
          <NeonButton onClick={nextRound} color="#00e676" size="lg" style={{ width: '100%', maxWidth: 320 }}>{t.nextTrack}</NeonButton>
        )}
        {phase === 'playing' && (
          <NeonButton onClick={() => { clearInterval(timerRef.current); if (audioRef.current) audioRef.current.pause(); try { ytPlayerRef.current?.pauseVideo(); } catch {} setPhase('stopped'); setTimeLeft(null); }} color="#7c4dff" size="sm">
            {t.pause}
          </NeonButton>
        )}
      </div>

      {/* Settings recap */}
      <div style={{ marginTop: 20, display: 'flex', gap: 8, flexWrap: 'wrap', justifyContent: 'center' }}>
        {[
          `🎵 ${settings.playlistName}`,
          settings.startMode === 'random' ? t.randomStart : t.beginStart,
          settings.listenDuration === 0 ? t.fullTrack : `⏱ ${settings.listenDuration}s`,
        ].map(tag => (
          <span key={tag} style={{ background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 20, padding: '4px 12px', fontSize: '0.75rem', color: '#8888aa' }}>{tag}</span>
        ))}
      </div>
    </div>
  );
}

// ─── Films & Series ───────────────────────────────────────────────────────────

function MovieSetupScreen({ onStart, onBack }) {
  const { t, lang } = useLang();
  const [contentType, setContentType] = useState('both');
  const [genres, setGenres] = useState([]);
  const [selectedGenres, setSelectedGenres] = useState([]);
  const [hintTypes, setHintTypes] = useState(['synopsis', 'image', 'trailer', 'soundtrack']);
  const [minScore, setMinScore] = useState(6.5);
  const [minYear, setMinYear] = useState(1900);
  const [westernOnly, setWesternOnly] = useState(true);
  const [loadingGenres, setLoadingGenres] = useState(true);
  const [loadingContent, setLoadingContent] = useState(false);
  const [genreError, setGenreError] = useState(false);

  const langMap = { nl: 'nl-NL', en: 'en-US', fr: 'fr-FR' };

  useEffect(() => {
    setLoadingGenres(true);
    setGenreError(false);
    setSelectedGenres([]);
    fetch(`${API}/tmdb/genres?type=${contentType}&language=${langMap[lang] || 'en-US'}`)
      .then(r => r.json())
      .then(d => { setGenres(d.genres || []); setLoadingGenres(false); })
      .catch(() => { setGenreError(true); setLoadingGenres(false); });
  }, [contentType, lang]);

  const toggleGenre = (id) => {
    setSelectedGenres(prev =>
      prev.includes(id) ? prev.filter(g => g !== id) : [...prev, id]
    );
  };

  const toggleHintType = (type) => {
    setHintTypes(prev => {
      if (prev.includes(type)) {
        if (prev.length <= 1) return prev;
        return prev.filter(h => h !== type);
      }
      return [...prev, type];
    });
  };

  const handleStart = async () => {
    setLoadingContent(true);
    const url = new URL(`${API}/tmdb/content`);
    url.searchParams.set('type', contentType);
    url.searchParams.set('language', langMap[lang] || 'en-US');
    url.searchParams.set('pages', 5);
    url.searchParams.set('min_score', minScore.toFixed(1));
    url.searchParams.set('min_year', minYear);
    url.searchParams.set('western_only', westernOnly ? 'true' : 'false');
    if (selectedGenres.length > 0) url.searchParams.set('genre_ids', selectedGenres.join(','));
    try {
      const { items } = await fetch(url).then(r => r.json());
      onStart({ items: shuffle([...(items || [])]), hintTypes, contentType, minScore });
    } catch {
      setLoadingContent(false);
    }
  };

  const hintOptions = [
    { v: 'synopsis', label: t.hintSynopsis, desc: t.hintSynopsisDesc },
    { v: 'image',    label: t.hintImage,    desc: t.hintImageDesc },
    { v: 'trailer',  label: t.hintTrailer,  desc: t.hintTrailerDesc },
    { v: 'soundtrack', label: t.hintSoundtrack, desc: t.hintSoundtrackDesc },
  ];

  const typeOptions = [
    { v: 'movie', label: t.contentMovies },
    { v: 'tv',    label: t.contentTv },
    { v: 'both',  label: t.contentBoth },
  ];

  return (
    <div style={{ minHeight: '100vh', padding: '24px 16px 40px', maxWidth: 480, margin: '0 auto' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 24 }}>
        <button onClick={onBack} style={{ background: 'none', border: 'none', color: '#8888aa', cursor: 'pointer', fontSize: '1.5rem', padding: 4 }}>←</button>
        <h1 style={{ fontFamily: 'Boogaloo, cursive', fontSize: '1.8rem', color: '#ff6400', margin: 0 }}>{t.movieSetupTitle}</h1>
      </div>

      {/* Content type */}
      <Card style={{ marginBottom: 16 }} glow="#ff6400">
        <h3 style={{ fontFamily: 'Boogaloo, cursive', fontSize: '1.2rem', color: '#ff6400', marginBottom: 12 }}>{t.contentType}</h3>
        <div style={{ display: 'flex', gap: 8 }}>
          {typeOptions.map(opt => (
            <button
              key={opt.v}
              onClick={() => setContentType(opt.v)}
              style={{ flex: 1, padding: '12px 8px', background: contentType === opt.v ? 'rgba(255,100,0,0.25)' : 'rgba(255,255,255,0.05)', border: `2px solid ${contentType === opt.v ? '#ff6400' : 'transparent'}`, borderRadius: 12, color: contentType === opt.v ? '#ff6400' : '#ccc', cursor: 'pointer', fontWeight: contentType === opt.v ? 700 : 400, fontSize: '0.85rem', transition: 'all 0.2s' }}
            >
              {opt.label}
            </button>
          ))}
        </div>
      </Card>

      {/* Genre filter */}
      <Card style={{ marginBottom: 16 }} glow="#00e5ff">
        <h3 style={{ fontFamily: 'Boogaloo, cursive', fontSize: '1.2rem', color: '#00e5ff', marginBottom: 12 }}>{t.genreFilter}</h3>
        {loadingGenres ? (
          <div style={{ color: '#8888aa', fontSize: '0.85rem', textAlign: 'center' }}>⏳ {t.loadingGenres}</div>
        ) : genreError ? (
          <div style={{ color: '#ff2d78', fontSize: '0.85rem', textAlign: 'center' }}>{t.noTmdbKey}</div>
        ) : (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
            <button
              onClick={() => setSelectedGenres([])}
              style={{ padding: '7px 14px', borderRadius: 20, border: `2px solid ${selectedGenres.length === 0 ? '#00e5ff' : 'rgba(255,255,255,0.15)'}`, background: selectedGenres.length === 0 ? 'rgba(0,229,255,0.18)' : 'rgba(255,255,255,0.05)', color: selectedGenres.length === 0 ? '#00e5ff' : '#8888aa', fontSize: '0.82rem', fontWeight: selectedGenres.length === 0 ? 700 : 400, cursor: 'pointer', transition: 'all 0.15s' }}
            >
              {t.genreAll}
            </button>
            {genres.map(g => {
              const active = selectedGenres.includes(g.id);
              return (
                <button
                  key={g.id}
                  onClick={() => toggleGenre(g.id)}
                  style={{ padding: '7px 14px', borderRadius: 20, border: `2px solid ${active ? '#00e5ff' : 'rgba(255,255,255,0.15)'}`, background: active ? 'rgba(0,229,255,0.18)' : 'rgba(255,255,255,0.05)', color: active ? '#00e5ff' : '#8888aa', fontSize: '0.82rem', fontWeight: active ? 700 : 400, cursor: 'pointer', transition: 'all 0.15s' }}
                >
                  {g.name}
                </button>
              );
            })}
          </div>
        )}
      </Card>

      {/* Hint types */}
      <Card style={{ marginBottom: 16 }} glow="#7c4dff">
        <h3 style={{ fontFamily: 'Boogaloo, cursive', fontSize: '1.2rem', color: '#7c4dff', marginBottom: 12 }}>{t.hintTypesLabel}</h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {hintOptions.map(opt => {
            const active = hintTypes.includes(opt.v);
            return (
              <button
                key={opt.v}
                onClick={() => toggleHintType(opt.v)}
                style={{ padding: '10px 16px', background: active ? 'rgba(124,77,255,0.2)' : 'rgba(255,255,255,0.05)', border: `2px solid ${active ? '#7c4dff' : 'transparent'}`, borderRadius: 10, color: '#fff', cursor: 'pointer', textAlign: 'left', display: 'flex', alignItems: 'center', justifyContent: 'space-between', transition: 'all 0.2s' }}
              >
                <div>
                  <div style={{ fontSize: '0.9rem', fontWeight: active ? 700 : 400, color: active ? '#7c4dff' : '#ccc' }}>{opt.label}</div>
                  <div style={{ fontSize: '0.72rem', color: '#8888aa' }}>{opt.desc}</div>
                </div>
                <div style={{ width: 22, height: 22, borderRadius: '50%', background: active ? '#7c4dff' : 'rgba(255,255,255,0.1)', border: `2px solid ${active ? '#7c4dff' : 'rgba(255,255,255,0.2)'}`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.75rem', flexShrink: 0 }}>
                  {active ? '✓' : ''}
                </div>
              </button>
            );
          })}
        </div>
      </Card>

      {/* Taalfilter westers / alles */}
      <Card style={{ marginBottom: 16 }} glow="#00e676">
        <h3 style={{ fontFamily: 'Boogaloo, cursive', fontSize: '1.2rem', color: '#00e676', marginBottom: 12 }}>{t.westernOnlyLabel}</h3>
        <div style={{ display: 'flex', gap: 8 }}>
          {[
            { v: true,  label: t.westernOnlyOn,  desc: t.westernOnlyOnDesc },
            { v: false, label: t.westernOnlyOff, desc: t.westernOnlyOffDesc },
          ].map(opt => (
            <button
              key={String(opt.v)}
              onClick={() => setWesternOnly(opt.v)}
              style={{
                flex: 1, padding: '12px 10px', borderRadius: 12, cursor: 'pointer', textAlign: 'left', transition: 'all 0.2s',
                background: westernOnly === opt.v ? 'rgba(0,230,118,0.18)' : 'rgba(255,255,255,0.05)',
                border: `2px solid ${westernOnly === opt.v ? '#00e676' : 'transparent'}`,
              }}
            >
              <div style={{ fontSize: '0.9rem', fontWeight: westernOnly === opt.v ? 700 : 400, color: westernOnly === opt.v ? '#00e676' : '#ccc', marginBottom: 3 }}>{opt.label}</div>
              <div style={{ fontSize: '0.72rem', color: '#8888aa', lineHeight: 1.3 }}>{opt.desc}</div>
            </button>
          ))}
        </div>
      </Card>

      {/* Minimum score slider */}
      <Card style={{ marginBottom: 16 }} glow="#ffd600">
        <h3 style={{ fontFamily: 'Boogaloo, cursive', fontSize: '1.2rem', color: '#ffd600', marginBottom: 12 }}>{t.minScoreLabel}</h3>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 12 }}>
          <div style={{ fontFamily: 'Boogaloo, cursive', fontSize: '2.4rem', color: '#ff6400', minWidth: 56, textAlign: 'center', lineHeight: 1 }}>
            {minScore.toFixed(1)}
          </div>
          <div style={{ flex: 1, fontSize: '0.8rem', color: '#8888aa', lineHeight: 1.4 }}>
            {t.minScoreHint(minScore.toFixed(1))}
          </div>
        </div>
        <input
          type="range"
          className="score-slider"
          min={5}
          max={9}
          step={0.1}
          value={minScore}
          onChange={e => setMinScore(parseFloat(e.target.value))}
          style={{ background: `linear-gradient(to right, #ff6400 0%, #ff6400 ${((minScore - 5) / 4) * 100}%, rgba(255,255,255,0.15) ${((minScore - 5) / 4) * 100}%, rgba(255,255,255,0.15) 100%)` }}
        />
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.72rem', color: '#555577', marginTop: 6 }}>
          <span>5.0</span><span>6.0</span><span>7.0</span><span>8.0</span><span>9.0</span>
        </div>
      </Card>

      {/* Minimum jaartal slider */}
      {(() => {
        const currentYear = new Date().getFullYear();
        const pct = ((minYear - 1900) / (currentYear - 1900)) * 100;
        const tickYears = [1900, 1950, 1970, 1990, 2010, currentYear];
        return (
          <Card style={{ marginBottom: 16 }} glow="#00e5ff">
            <h3 style={{ fontFamily: 'Boogaloo, cursive', fontSize: '1.2rem', color: '#00e5ff', marginBottom: 12 }}>{t.minYearLabel}</h3>
            <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 12 }}>
              <div style={{ fontFamily: 'Boogaloo, cursive', fontSize: '2.4rem', color: '#00e5ff', minWidth: 72, textAlign: 'center', lineHeight: 1 }}>
                {minYear === 1900 ? '∞' : minYear}
              </div>
              <div style={{ flex: 1, fontSize: '0.8rem', color: '#8888aa', lineHeight: 1.4 }}>
                {t.minYearHint(minYear)}
              </div>
            </div>
            <input
              type="range"
              className="score-slider"
              min={1900}
              max={currentYear}
              step={1}
              value={minYear}
              onChange={e => setMinYear(parseInt(e.target.value, 10))}
              style={{ background: `linear-gradient(to right, #00e5ff 0%, #00e5ff ${pct}%, rgba(255,255,255,0.15) ${pct}%, rgba(255,255,255,0.15) 100%)` }}
            />
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.72rem', color: '#555577', marginTop: 6 }}>
              {tickYears.map(y => <span key={y}>{y === 1900 ? 'alles' : y}</span>)}
            </div>
          </Card>
        );
      })()}

      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <NeonButton onClick={handleStart} disabled={loadingContent || loadingGenres} color="#ff6400" size="lg">
          {loadingContent ? `⏳ ${t.loadingContent}` : t.startMovieGame}
        </NeonButton>
      </div>
    </div>
  );
}

function MovieGameScreen({ settings, onBack }) {
  const { t } = useLang();
  const [queue, setQueue] = useState(() => shuffle([...settings.items]));
  const [itemIndex, setItemIndex] = useState(0);
  const [currentItem, setCurrentItem] = useState(null);
  const [phase, setPhase] = useState('ready'); // 'ready' | 'loading-video' | 'hinting' | 'revealed'
  const [hintType, setHintType] = useState(null);
  const [videoState, setVideoState] = useState('idle'); // 'idle' | 'loading' | 'ready' | 'error' | 'missing-key'
  const [hintRevealed, setHintRevealed] = useState(false);
  const [showConfetti, setShowConfetti] = useState(false);
  const [round, setRound] = useState(1);
  const [restarted, setRestarted] = useState(false);
  const [soundtrackUrl, setSoundtrackUrl] = useState(null);

  const ytPlayerRef = useRef(null);
  const ytApiReadyRef = useRef(false);
  const pendingVideoIdRef = useRef(null);
  const pendingMuteRef = useRef(false);
  const audioRef = useRef(null);
  const queueRef = useRef(queue);
  const itemIndexRef = useRef(itemIndex);

  queueRef.current = queue;
  itemIndexRef.current = itemIndex;

  const initYTPlayer = () => {
    if (ytPlayerRef.current) return;
    // Safety check: only init when the div is actually in the DOM
    if (!document.getElementById('yt-player-div')) return;
    ytPlayerRef.current = new window.YT.Player('yt-player-div', {
      width: '100%',
      height: '100%',
      playerVars: { autoplay: 1, controls: 0, modestbranding: 1, rel: 0, iv_load_policy: 3 },
      events: {
        onReady: () => {
          ytApiReadyRef.current = true;
          if (pendingMuteRef.current) { ytPlayerRef.current.mute(); } else { ytPlayerRef.current.unMute(); }
          if (pendingVideoIdRef.current) {
            ytPlayerRef.current.loadVideoById(pendingVideoIdRef.current);
            pendingVideoIdRef.current = null;
          }
        },
      },
    });
  };

  // Mount: enkel het YT API-script laden; player wordt aangemaakt wanneer de div in de DOM komt
  useEffect(() => {
    const prev = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = () => {
      if (prev) prev();
      // Als de div al in de DOM staat op het moment dat de API laadt, init meteen
      if (document.getElementById('yt-player-div') && !ytPlayerRef.current) {
        initYTPlayer();
      }
    };
    if (!document.getElementById('yt-api-script') && !window.YT?.Player) {
      const s = document.createElement('script');
      s.id = 'yt-api-script';
      s.src = 'https://www.youtube.com/iframe_api';
      document.head.appendChild(s);
    }
    return () => {
      if (audioRef.current) { audioRef.current.pause(); audioRef.current.src = ''; }
      try { ytPlayerRef.current?.destroy(); } catch {}
      ytPlayerRef.current = null;
    };
  }, []);

  // Wanneer videoState 'ready' wordt voor trailer → div is net in de DOM → player aanmaken of video laden
  useEffect(() => {
    if (videoState === 'ready' && hintType === 'trailer') {
      if (!ytPlayerRef.current && window.YT?.Player) {
        initYTPlayer();
      } else if (ytPlayerRef.current && ytApiReadyRef.current && pendingVideoIdRef.current) {
        if (pendingMuteRef.current) ytPlayerRef.current.mute(); else ytPlayerRef.current.unMute();
        ytPlayerRef.current.loadVideoById(pendingVideoIdRef.current);
        pendingVideoIdRef.current = null;
      }
    }
  }, [videoState]); // eslint-disable-line

  // Soundtrack: afspelen via native audio zodra URL beschikbaar is en fase 'hinting'
  useEffect(() => {
    if (hintType === 'soundtrack' && soundtrackUrl && audioRef.current && phase === 'hinting') {
      audioRef.current.src = soundtrackUrl;
      audioRef.current.play().catch(() => {});
    }
  }, [soundtrackUrl, phase]); // eslint-disable-line

  const loadYouTube = async (item) => {
    setVideoState('loading');
    try {
      const res = await fetch(`${API}/tmdb/youtube?tmdb_id=${item.id}&title=${encodeURIComponent(item.title)}&year=${item.year}&hint_type=trailer&media_type=${item.mediaType}`);
      if (!res.ok) {
        setVideoState(res.status === 503 ? 'missing-key' : 'error');
        return;
      }
      const { videoId } = await res.json();
      pendingMuteRef.current = false;
      pendingVideoIdRef.current = videoId;
      setVideoState('ready');
    } catch {
      setVideoState('error');
    }
  };

  const loadSoundtrack = async (item) => {
    setVideoState('loading');
    try {
      const res = await fetch(`${API}/tmdb/soundtrack?tmdb_id=${item.id}&title=${encodeURIComponent(item.title)}`);
      if (!res.ok) {
        setVideoState('error');
        return;
      }
      const { previewUrl } = await res.json();
      setSoundtrackUrl(previewUrl);
      setVideoState('ready');
    } catch {
      setVideoState('error');
    }
  };

  const loadItem = async (item) => {
    if (audioRef.current) { audioRef.current.pause(); audioRef.current.src = ''; }
    try { ytPlayerRef.current?.destroy(); } catch {}
    ytPlayerRef.current = null;
    ytApiReadyRef.current = false;
    pendingVideoIdRef.current = null;
    setSoundtrackUrl(null);
    setCurrentItem(item);
    setHintRevealed(false);
    setVideoState('idle');

    const chosen = settings.hintTypes[Math.floor(Math.random() * settings.hintTypes.length)];
    setHintType(chosen);

    if (chosen === 'trailer') {
      setPhase('loading-video');
      await loadYouTube(item);
      setPhase('hinting');
    } else if (chosen === 'soundtrack') {
      setPhase('loading-video');
      await loadSoundtrack(item);
      setPhase('hinting');
    } else {
      setPhase('hinting');
    }
  };

  const playNext = () => {
    let q = queueRef.current;
    let idx = itemIndexRef.current;
    let didRestart = false;

    if (idx >= q.length) {
      q = shuffle([...settings.items]);
      idx = 0;
      didRestart = true;
      setQueue(q);
    }
    setItemIndex(idx + 1);

    if (didRestart) {
      setRestarted(true);
      setTimeout(() => setRestarted(false), 3000);
    }
    loadItem(q[idx]);
  };

  const handleReveal = () => {
    if (audioRef.current) audioRef.current.pause();
    try { ytPlayerRef.current?.pauseVideo(); } catch {}
    setShowConfetti(true);
    setTimeout(() => setShowConfetti(false), 4000);
    setPhase('revealed');
  };

  const nextRound = () => {
    setRound(r => r + 1);
    playNext();
  };

  return (
    <div style={{ minHeight: '100vh', padding: '16px 16px 40px', maxWidth: 480, margin: '0 auto' }}>
      {showConfetti && <Confetti />}
      <audio ref={audioRef} style={{ display: 'none' }} />

      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
        <button
          onClick={() => { if (audioRef.current) audioRef.current.pause(); try { ytPlayerRef.current?.stopVideo(); } catch {} onBack(); }}
          style={{ background: 'none', border: 'none', color: '#8888aa', cursor: 'pointer', fontSize: '1.5rem', padding: 4 }}
        >←</button>
        <div style={{ fontFamily: 'Boogaloo, cursive', fontSize: '1.4rem', color: '#ff6400' }}>{t.movieRound(round)}</div>
        <div style={{ width: 32 }} />
      </div>

      {restarted && (
        <div style={{ textAlign: 'center', color: '#ff6400', fontSize: '0.85rem', marginBottom: 8 }}>{t.movieRestarted}</div>
      )}

      {/* Hint weergave */}
      {phase !== 'ready' && currentItem && (
        <div style={{ marginBottom: 12 }}>

          {/* Hint type badge */}
          {hintType && phase !== 'revealed' && (
            <div style={{ textAlign: 'center', marginBottom: 8 }}>
              <span style={{ background: 'rgba(124,77,255,0.2)', border: '1px solid #7c4dff44', borderRadius: 20, padding: '3px 12px', fontSize: '0.78rem', color: '#7c4dff' }}>
                {t.hintTypeLabel(hintType)}
              </span>
            </div>
          )}

          {/* TRAILER: YouTube player */}
          {hintType === 'trailer' && (
            <div style={{ position: 'relative', width: '100%', paddingTop: '56.25%', marginBottom: 8, borderRadius: 14, overflow: 'hidden', background: '#000' }}>
              <div id="yt-player-div" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', pointerEvents: videoState === 'ready' ? 'auto' : 'none' }} />

              {/* Blur-balk bovenaan: verbergt de YouTube-titel */}
              {videoState === 'ready' && (
                <div style={{
                  position: 'absolute', top: 0, left: 0, right: 0,
                  height: 52,
                  backdropFilter: 'blur(14px)',
                  WebkitBackdropFilter: 'blur(14px)',
                  background: 'rgba(0,0,0,0.35)',
                  zIndex: 3,
                  borderRadius: '14px 14px 0 0',
                  pointerEvents: 'none',
                }} />
              )}

              {/* Loading / error overlay */}
              {(videoState === 'loading' || videoState === 'error' || videoState === 'missing-key') && (
                <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.9)', display: 'flex', alignItems: 'center', justifyContent: 'center', touchAction: 'pan-y' }}>
                  {videoState === 'loading' && <div style={{ textAlign: 'center', color: '#8888aa' }}><div style={{ fontSize: 32, animation: 'spin-slow 1s linear infinite' }}>⏳</div><div style={{ fontSize: '0.78rem', marginTop: 6 }}>{t.videoLoading}</div></div>}
                  {videoState === 'error' && <div style={{ textAlign: 'center', color: '#ff2d78', fontSize: '0.8rem' }}><div style={{ fontSize: 28 }}>⚠️</div><div>{t.videoError}</div></div>}
                  {videoState === 'missing-key' && <div style={{ textAlign: 'center', color: '#ffd600', fontSize: '0.78rem', padding: '0 12px' }}><div style={{ fontSize: 28 }}>🔑</div><div style={{ marginTop: 4 }}>{t.ytApiMissing}</div></div>}
                </div>
              )}
            </div>
          )}

          {/* SOUNDTRACK: Deezer audio — visueel: blurred backdrop + equalizer */}
          {hintType === 'soundtrack' && phase !== 'revealed' && (
            <div style={{ position: 'relative', width: '100%', paddingTop: '56.25%', marginBottom: 8, borderRadius: 14, overflow: 'hidden', background: '#000' }}>
              {currentItem.backdropPath && (
                <img
                  src={`https://image.tmdb.org/t/p/w500${currentItem.backdropPath}`}
                  alt=""
                  style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', filter: 'blur(16px) brightness(0.45)', transform: 'scale(1.1)' }}
                />
              )}
              <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {videoState === 'loading' && <div style={{ textAlign: 'center', color: '#8888aa' }}><div style={{ fontSize: 32, animation: 'spin-slow 1s linear infinite' }}>⏳</div><div style={{ fontSize: '0.78rem', marginTop: 6 }}>{t.videoLoading}</div></div>}
                {videoState === 'ready' && <Equalizer playing={phase === 'hinting'} />}
                {videoState === 'error' && <div style={{ textAlign: 'center', color: '#ff2d78', fontSize: '0.8rem' }}><div style={{ fontSize: 28 }}>⚠️</div><div style={{ marginTop: 4 }}>{t.videoError}</div></div>}
              </div>
            </div>
          )}

          {/* SYNOPSIS hint */}
          {hintType === 'synopsis' && (
            <div style={{ position: 'relative', marginBottom: 8 }}>
              <div style={{
                padding: '16px',
                background: 'rgba(26,26,46,0.95)',
                border: '1px solid rgba(124,77,255,0.3)',
                borderRadius: 14,
                fontSize: '0.9rem',
                lineHeight: 1.6,
                color: '#e0e0ff',
                filter: hintRevealed ? 'none' : 'blur(7px)',
                userSelect: hintRevealed ? 'auto' : 'none',
                transition: 'filter 0.4s',
                minHeight: 80,
              }}>
                {currentItem.overview || '—'}
              </div>
              {!hintRevealed && (
                <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <NeonButton onClick={() => setHintRevealed(true)} color="#7c4dff" size="sm">{t.synopsisRevealHint}</NeonButton>
                </div>
              )}
            </div>
          )}

          {/* BEELD hint */}
          {hintType === 'image' && (
            <div style={{ position: 'relative', width: '100%', paddingTop: '56.25%', marginBottom: 8, borderRadius: 14, overflow: 'hidden', background: '#111' }}>
              {currentItem.backdropPath ? (
                <img
                  src={`https://image.tmdb.org/t/p/w780${currentItem.backdropPath}`}
                  alt=""
                  style={{
                    position: 'absolute', inset: 0, width: '100%', height: '100%',
                    objectFit: 'cover',
                    filter: hintRevealed ? 'none' : 'blur(18px)',
                    transform: hintRevealed ? 'scale(1)' : 'scale(1.08)',
                    transition: 'filter 0.5s, transform 0.5s',
                  }}
                />
              ) : (
                <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#8888aa', fontSize: 48 }}>🎬</div>
              )}
              {!hintRevealed && currentItem.backdropPath && (
                <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <NeonButton onClick={() => setHintRevealed(true)} color="#ff6400" size="sm">{t.synopsisRevealHint}</NeonButton>
                </div>
              )}
            </div>
          )}
        </div>
      )}

      {/* Info card */}
      <Card glow="#ff6400" style={{ textAlign: 'center', marginBottom: 16, padding: '20px' }}>
        {phase === 'ready' && (
          <div>
            <div style={{ fontSize: 56, marginBottom: 10, animation: 'float 3s ease-in-out infinite' }}>🎬</div>
            <p style={{ color: '#ccc', marginBottom: 16 }}>{t.readyToStart}</p>
            <NeonButton onClick={playNext} color="#ff6400" size="lg">{t.startFirst}</NeonButton>
          </div>
        )}

        {phase === 'loading-video' && (
          <div>
            <div style={{ fontSize: 32, animation: 'spin-slow 1s linear infinite', marginBottom: 8 }}>⏳</div>
            <p style={{ color: '#8888aa', fontSize: '0.85rem' }}>{t.videoLoading}</p>
          </div>
        )}

        {phase === 'hinting' && currentItem && (
          <div>
            <p style={{ color: '#8888aa', fontSize: '0.85rem', marginBottom: 6 }}>{t.moviePlaying}</p>
            <p style={{ color: '#555566', fontSize: '0.75rem' }}>
              {currentItem.mediaType === 'movie' ? '🎬' : '📺'} {currentItem.mediaType === 'movie' ? 'Film' : 'Serie'}
            </p>
          </div>
        )}

        {phase === 'revealed' && currentItem && (
          <div style={{ animation: 'bounce-in 0.5s ease-out' }}>
            {currentItem.posterPath ? (
              <img
                src={`https://image.tmdb.org/t/p/w342${currentItem.posterPath}`}
                alt="Poster"
                style={{ width: 100, height: 150, borderRadius: 10, objectFit: 'cover', margin: '0 auto 12px', display: 'block', border: '3px solid #ff6400', boxShadow: '0 0 20px #ff640055', animation: 'float 3s ease-in-out infinite' }}
              />
            ) : (
              <div style={{ width: 100, height: 100, borderRadius: 12, background: '#ff640022', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px', fontSize: 36 }}>
                {currentItem.mediaType === 'movie' ? '🎬' : '📺'}
              </div>
            )}
            <div style={{ fontFamily: 'Boogaloo, cursive', fontSize: '1.6rem', color: '#ffd600', marginBottom: 4, lineHeight: 1.2 }}>{currentItem.title}</div>
            <div style={{ fontSize: '0.85rem', color: '#8888aa', marginBottom: 8 }}>{currentItem.mediaType === 'movie' ? '🎬 Film' : '📺 Serie'}</div>
            <div style={{ display: 'inline-block', background: 'linear-gradient(135deg, #ff6400, #ff2d78)', borderRadius: 20, padding: '4px 16px', fontFamily: 'Boogaloo, cursive', fontSize: '1.2rem' }}>
              📅 {currentItem.year}
            </div>
          </div>
        )}
      </Card>

      {/* Acties */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, alignItems: 'center' }}>
        {phase === 'hinting' && (
          <NeonButton onClick={handleReveal} color="#ffd600" size="lg" style={{ width: '100%', maxWidth: 320 }}>{t.revealMovie}</NeonButton>
        )}
        {phase === 'revealed' && (
          <NeonButton onClick={nextRound} color="#00e676" size="lg" style={{ width: '100%', maxWidth: 320 }}>{t.nextMovie}</NeonButton>
        )}
      </div>

      {/* Settings recap */}
      <div style={{ marginTop: 20, display: 'flex', gap: 8, flexWrap: 'wrap', justifyContent: 'center' }}>
        {[
          settings.contentType === 'movie' ? t.contentMovies : settings.contentType === 'tv' ? t.contentTv : t.contentBoth,
          `📦 ${settings.items.length}`,
        ].map(tag => (
          <span key={tag} style={{ background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 20, padding: '4px 12px', fontSize: '0.75rem', color: '#8888aa' }}>{tag}</span>
        ))}
      </div>
    </div>
  );
}

// ─── PWA Install Banner ───────────────────────────────────────────────────────

function InstallBanner() {
  const { t } = useLang();
  const [prompt, setPrompt] = useState(null);
  const [dismissed, setDismissed] = useState(() => localStorage.getItem('pwa_dismissed') === '1');

  useEffect(() => {
    const handler = e => { e.preventDefault(); setPrompt(e); };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  if (!prompt || dismissed) return null;

  const install = async () => {
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    if (outcome === 'accepted') setPrompt(null);
  };

  const dismiss = () => { localStorage.setItem('pwa_dismissed', '1'); setDismissed(true); };

  return (
    <div style={{ position: 'fixed', bottom: 20, left: 16, right: 16, zIndex: 1000, background: 'linear-gradient(135deg, #1a1a2e, #16213e)', border: '2px solid #7c4dff', borderRadius: 16, padding: '14px 16px', display: 'flex', alignItems: 'center', gap: 12, boxShadow: '0 0 30px #7c4dff44, 0 8px 32px rgba(0,0,0,0.6)', animation: 'slide-up 0.4s ease-out' }}>
      <span style={{ fontSize: 28 }}>📲</span>
      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: 700, fontSize: '0.9rem' }}>{t.installTitle}</div>
        <div style={{ fontSize: '0.75rem', color: '#8888aa' }}>{t.installSubtitle}</div>
      </div>
      <NeonButton onClick={install} color="#7c4dff" size="sm">{t.install}</NeonButton>
      <button onClick={dismiss} style={{ background: 'none', border: 'none', color: '#8888aa', cursor: 'pointer', fontSize: '1.2rem', padding: '0 4px' }}>✕</button>
    </div>
  );
}

// ─── App root ─────────────────────────────────────────────────────────────────

export default function App() {
  const { token, logout } = useToken();
  const [screen, setScreen] = useState('mode');
  const [settings, setSettings] = useState(null);
  const [freeSettings, setFreeSettings] = useState(null);
  const [movieSettings, setMovieSettings] = useState(null);
  const [lang, setLang] = useState(() => localStorage.getItem('lang') || 'nl');

  const handleSetLang = (l) => { localStorage.setItem('lang', l); setLang(l); };

  useEffect(() => {
    if (token) setScreen('setup');
  }, [token]);

  const t = T[lang] || T.nl;

  return (
    <LangContext.Provider value={{ lang, setLang: handleSetLang }}>
      <InstallBanner />

      {screen === 'mode' && (
        <ModeScreen
          onChooseSpotify={() => setScreen('login')}
          onChooseFree={() => setScreen('free-setup')}
          onChooseMovies={() => setScreen('movie-setup')}
        />
      )}

      {screen === 'login' && <LoginScreen onBack={() => setScreen('mode')} />}

      {screen === 'setup' && token && (
        <>
          <div style={{ position: 'fixed', top: 12, right: 16, zIndex: 100 }}>
            <NeonButton onClick={logout} color="#ff2d78" size="sm">{t.logout}</NeonButton>
          </div>
          <SetupScreen token={token} onStart={(s) => { setSettings(s); setScreen('game'); }} />
        </>
      )}

      {screen === 'game' && token && settings && (
        <GameScreen token={token} settings={settings} onBack={() => setScreen('setup')} />
      )}

      {screen === 'free-setup' && (
        <FreeSetupScreen
          onStart={(s) => { setFreeSettings(s); setScreen('free-game'); }}
          onBack={() => setScreen('mode')}
        />
      )}

      {screen === 'free-game' && freeSettings && (
        <FreeGameScreen settings={freeSettings} onBack={() => setScreen('free-setup')} />
      )}

      {screen === 'movie-setup' && (
        <MovieSetupScreen
          onStart={(s) => { setMovieSettings(s); setScreen('movie-game'); }}
          onBack={() => setScreen('mode')}
        />
      )}

      {screen === 'movie-game' && movieSettings && (
        <MovieGameScreen settings={movieSettings} onBack={() => setScreen('movie-setup')} />
      )}
    </LangContext.Provider>
  );
}
